import React, { useEffect, useRef, useState } from "react";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { commonService } from "../../../../utils/commonService";
import { apiResponse } from "../../../../utils/apiResponse";
import moment from "moment";
import Loader from "../../../Loader/Loader";
import { compName } from "../../../../utils/constant";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import AddWidgetModal from "../../AddWidgetModal";
import WidgetDetailModal from "../../WidgetDetailModal";
import exampleFile from "../../../../Assets/Files/STR_analysis.xlsx";
import { Bar } from "react-chartjs-2";
import { Chart } from "chart.js/auto";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import RunningStar from "./RunningStar";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const WeeklyStar = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
    setWeeklyDate,
}) => {
    const userDetails = commonService.getLoginUserData();
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );
    const [selectedDate, setSelectedDate] = useState(
        new Date().setDate(new Date().getDate() - 7)
    );
    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState(null);
    const reportDataRef = useRef();
    const datesArrRef = useRef();
    const tableDataRef = useRef([]);
    const strDataRef = useRef();
    const weekDayArr = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Total",
    ];
    const tableObj = {
        Sunday: {},
        Monday: {},
        Tuesday: {},
        Wednesday: {},
        Thursday: {},
        Friday: {},
        Saturday: {},
        Total: {},
    };
    const tableDataRefSecond = useRef(tableObj);
    const [clickedTr, setClickedTr] = useState({
        mainRow: "",
        subRow: "",
        day: "",
        field: "",
    });
    const [showNoteSidebar, setShowNoteSidebar] = useState(false);
    const [strData, setStrData] = useState(null);
    const [widgetModal, setWidgetModal] = useState(false);
    const widgetDetailRef = useRef();
    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );
    const dayNames = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ];
    const { snapshottitle, propertyCode, snapshotId } = useParams();
    const [submitLoading, setSubmitLoading] = useState(false);
    const inputFile = useRef();
    const [fileImportLoading, setFileImportLoading] = useState(false);
    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const closeNoteSideBar = () => {
        setShowNoteSidebar(false);
    };

    function getWeekStartAndEnd(date) {
        const currentDate = new Date(date);

        const weekStart = new Date(currentDate);
        weekStart.setDate(currentDate.getDate() - currentDate.getDay());

        const weekEnd = new Date(currentDate);
        weekEnd.setDate(currentDate.getDate() + (6 - currentDate.getDay()));

        return {
            start: weekStart,
            end: weekEnd,
        };
    }

    const inputDate = new Date(selectedDate);
    const weekDates = getWeekStartAndEnd(inputDate);
    let firstday = new Date(weekDates.start);
    let lastday = new Date(weekDates.end);

    const [occChartData, setOccChartData] = useState(null);
    const [adrChartData, setAdrChartData] = useState(null);
    const [revParChartData, setRevParChartData] = useState(null);
    const [stayStartDate, setStayStartDate] = useState(new Date(weekDates.start));
    const [stayEndDate, setStayEndDate] = useState(new Date(weekDates.end));

    const [isOpen, setIsOpen] = useState(false);
    const handleStayDateChange = (dates) => {
        const [start] = dates;
        if (start) {
            let NewDates = getWeekStartAndEnd(start);
            setStayStartDate(NewDates?.start);
            setStayEndDate(NewDates?.end);
            /*getMonthlyReport(NewDates?.start, NewDates?.end);*/
            setIsOpen(false);
        }
    };

    //const handleStayDateChange = (dates) => {
    //    const [start, end] = dates;
    //    setStayStartDate(start);
    //    setStayEndDate(end ? end : "");
    //    /*setFileImportLoading(true);*/
    //    //if (start && end) {
    //    //    getMonthlyReport(start, end);
    //    //}
    //};

    useEffect(() => {
        getWeeklyReport();
        getStrReport();
    }, [stayStartDate]);

    const occChartOption = {
        scales: {
            y: {
                beginAtZero: true,
            },
        },
        plugins: {
            tooltip: {
                mode: "index",
                intersect: false,
            },
        },
        maintainAspectRatio: false,
    };

    const getWeeklyReport = async () => {
        setLoading(true);
        setOccChartData(null);
        setAdrChartData(null);
        setRevParChartData(null);

        let weeklyReportResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.STR_REPORT_REVPAK.GET_WEEKLY_REPORT,
                body: {
                    propertyCode: para?.propertyCode,
                    selectedDate: stayStartDate
                        ? commonService.getDateForNode(stayStartDate)
                        : "",
                },
            },
            false
        );

        let response = apiResponse(false, weeklyReportResponse);

        if (response?.isValidate) {
            tableDataRef.current = [];
            datesArrRef.current = commonService.getDateBetweenTwoDates(
                new Date(stayStartDate),
                new Date(stayEndDate)
            );
            let labels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
            let occCurrentYearMpi = {
                label: "Current Year MPI",
                data: [],
                backgroundColor: "#1CC26A",
                borderColor: "#1CC26A",
                // borderWidth: 1,
            },
                occLastYearMpi = {
                    label: "Last Year MPI",
                    data: [],
                    backgroundColor: "#1893E5",
                    borderColor: "#1893E5",
                    // borderWidth: 1,
                },
                adrCurrentYearMpi = {
                    label: "Current Year MPI",
                    data: [],
                    backgroundColor: "#1CC26A",
                    borderColor: "#1CC26A",
                    // borderWidth: 1,
                },
                adrLastYearMpi = {
                    label: "Last Year MPI",
                    data: [],
                    backgroundColor: "#1893E5",
                    borderColor: "#1893E5",
                    // borderWidth: 1,
                },
                revParCurrentYearMpi = {
                    label: "Current Year MPI",
                    data: [],
                    backgroundColor: "#1CC26A",
                    borderColor: "#1CC26A",
                    // borderWidth: 1,
                },
                revParLastYearMpi = {
                    label: "Last Year MPI",
                    data: [],
                    backgroundColor: "#1893E5",
                    borderColor: "#1893E5",
                    // borderWidth: 1,
                };

            datesArrRef.current?.map((item, index) => {
                let findObj = response?.data?.data?.filter(
                    (x) =>
                        moment(x?.StarReportDate).format("YYYY-MM-DD") ===
                        moment(item).format("YYYY-MM-DD")
                );
                let dateKey = moment(item).format("YYYY-MM-DD");

                if (findObj?.[0]) {
                    tableDataRef.current = [...tableDataRef.current, findObj?.[0]];
                    occCurrentYearMpi.data.push(
                        findObj?.[0]?.OccIndex ? findObj?.[0]?.OccIndex : 0
                    );
                    occLastYearMpi.data.push(
                        findObj?.[0]?.OccIndexLy ? findObj?.[0]?.OccIndexLy : 0
                    );

                    adrCurrentYearMpi.data.push(
                        findObj?.[0]?.AdrIndex ? findObj?.[0]?.AdrIndex : 0
                    );
                    adrLastYearMpi.data.push(
                        findObj?.[0]?.AdrIndexLy ? findObj?.[0]?.AdrIndexLy : 0
                    );

                    revParCurrentYearMpi.data.push(
                        findObj?.[0]?.RevparIndex ? findObj?.[0]?.RevparIndex : 0
                    );
                    revParLastYearMpi.data.push(
                        findObj?.[0]?.RevparIndexLy ? findObj?.[0]?.RevparIndexLy : 0
                    );
                } else {
                    tableDataRef.current = [
                        ...tableDataRef.current,
                        {
                            propertyCode: para?.propertyCode,
                            AsOfDate: para?.asOfDate,
                            StarReportDate: moment(item).format("YYYY-MM-DD"),
                            OccMyProperty: null,
                            OccMyPropertyChange: null,
                            OccMyPropertyLy: null,
                            OccCompset: null,
                            OccCompsetChange: null,
                            OccCompsetLy: null,
                            OccIndex: null,
                            OccIndexChange: null,
                            OccIndexLy: null,
                            AdrMyProperty: null,
                            AdrMyPropertyChange: null,
                            AdrMyPropertyLy: null,
                            AdrCompset: null,
                            AdrCompsetChange: null,
                            AdrCompsetLy: null,
                            AdrIndex: null,
                            AdrIndexChange: null,
                            AdrIndexLy: null,
                            RevparMyProperty: null,
                            RevparMyPropertyChange: null,
                            RevparMyPropertyLy: null,
                            RevparCompset: null,
                            RevparCompsetChange: null,
                            RevparCompsetLy: null,
                            RevparIndex: null,
                            RevparIndexChange: null,
                            RevparIndexLy: null,
                        },
                    ];
                    occCurrentYearMpi.data.push(0);
                    occLastYearMpi.data.push(0);

                    adrCurrentYearMpi.data.push(0);
                    adrLastYearMpi.data.push(0);

                    revParCurrentYearMpi.data.push(0);
                    revParLastYearMpi.data.push(0);
                }
            });

            let totalData = response?.data?.data?.filter(
                (x) => x.StarReportDate === null
            );
            if (totalData?.length > 0) {
                tableDataRef.current = [...tableDataRef.current, totalData?.[0]];
            }
            setReportData(tableDataRef.current);
            setOccChartData({
                labels: labels,
                datasets: [occCurrentYearMpi, occLastYearMpi],
            });
            setAdrChartData({
                labels: labels,
                datasets: [adrCurrentYearMpi, adrLastYearMpi],
            });
            setRevParChartData({
                labels: labels,
                datasets: [revParCurrentYearMpi, revParLastYearMpi],
            });
            reportDataRef.current = tableDataRef.current;
            setLoading(false);
        }

        if (!response?.isValidate) {
            tableDataRef.current = [];
            datesArrRef.current = commonService.getDateBetweenTwoDates(
                new Date(firstday),
                new Date(lastday)
            );
            datesArrRef.current?.map((item, index) => {
                let findObj = response?.data?.data?.filter(
                    (x) =>
                        moment(x?.StarReportDate).format("YYYY-MM-DD") ===
                        moment(item).format("YYYY-MM-DD")
                );
                let dateKey = moment(item).format("YYYY-MM-DD");

                if (findObj?.[0]) {
                    tableDataRef.current = [...tableDataRef.current, findObj?.[0]];
                } else {
                    tableDataRef.current = [
                        ...tableDataRef.current,
                        {
                            propertyCode: para?.propertyCode,
                            AsOfDate: para?.asOfDate,
                            StarReportDate: moment(item).format("YYYY-MM-DD"),
                            OccMyProperty: null,
                            OccMyPropertyChange: null,
                            OccMyPropertyLy: null,
                            OccCompset: null,
                            OccCompsetChange: null,
                            OccCompsetLy: null,
                            OccIndex: null,
                            OccIndexChange: null,
                            OccIndexLy: null,
                            AdrMyProperty: null,
                            AdrMyPropertyChange: null,
                            AdrMyPropertyLy: null,
                            AdrCompset: null,
                            AdrCompsetChange: null,
                            AdrCompsetLy: null,
                            AdrIndex: null,
                            AdrIndexChange: null,
                            AdrIndexLy: null,
                            RevparMyProperty: null,
                            RevparMyPropertyChange: null,
                            RevparMyPropertyLy: null,
                            RevparCompset: null,
                            RevparCompsetChange: null,
                            RevparCompsetLy: null,
                            RevparIndex: null,
                            RevparIndexChange: null,
                            RevparIndexLy: null,
                        },
                    ];
                }
            });
            tableDataRef.current = [
                ...tableDataRef.current,
                {
                    propertyCode: para?.propertyCode,
                    AsOfDate: para?.asOfDate,
                    StarReportDate: null,
                    OccMyProperty: null,
                    OccMyPropertyChange: null,
                    OccMyPropertyLy: null,
                    OccCompset: null,
                    OccCompsetChange: null,
                    OccCompsetLy: null,
                    OccIndex: null,
                    OccIndexChange: null,
                    OccIndexLy: null,
                    AdrMyProperty: null,
                    AdrMyPropertyChange: null,
                    AdrMyPropertyLy: null,
                    AdrCompset: null,
                    AdrCompsetChange: null,
                    AdrCompsetLy: null,
                    AdrIndex: null,
                    AdrIndexChange: null,
                    AdrIndexLy: null,
                    RevparMyProperty: null,
                    RevparMyPropertyChange: null,
                    RevparMyPropertyLy: null,
                    RevparCompset: null,
                    RevparCompsetChange: null,
                    RevparCompsetLy: null,
                    RevparIndex: null,
                    RevparIndexChange: null,
                    RevparIndexLy: null,
                },
            ];
            setReportData(tableDataRef.current);
            reportDataRef.current = tableDataRef.current;
            setLoading(false);
        }
    };

    const getStrReport = async () => {
        // setLoading(true);
        let strReportResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.STR_REPORT_REVPAK.GET_RUNNING_STR_REPORT,
                body: {
                    propertyCode: para?.propertyCode,
                    selectedDate: stayStartDate
                        ? commonService.getDateForNode(stayStartDate)
                        : "",
                },
            },
            false
        );

        let response = apiResponse(false, strReportResponse);

        if (response?.isValidate) {
            weekDayArr?.map((item, index) => {
                if (item === "Total") {
                    let findObj = response?.data?.data?.filter(
                        (x) => x?.Weekday === null || x?.Weekday === "Total"
                    );
                    tableDataRefSecond.current[item] = findObj?.[0];
                } else {
                    let findObj = response?.data?.data?.filter(
                        (x) => x?.Weekday?.trim() === item
                    );
                    tableDataRefSecond.current[item] = findObj?.[0];
                }
            });
            strDataRef.current = response?.data?.data;
            setStrData(response?.data?.data);
            // setLoading(false);
        }

        if (!response?.isValidate) {
            let dummyData = [
                {
                    Weekday: "Sunday",
                    propertyCode: para?.propertyCode,
                    AsOfDate: para?.asOfDate,
                    OccMyProperty: null,
                    OccMyPropertyChange: null,
                    OccMyPropertyLy: null,
                    OccCompset: null,
                    OccCompsetChange: null,
                    OccCompsetLy: null,
                    OccIndex: null,
                    OccIndexChange: null,
                    OccIndexLy: null,
                    AdrMyProperty: null,
                    AdrMyPropertyChange: null,
                    AdrMyPropertyLy: null,
                    AdrCompset: null,
                    AdrCompsetChange: null,
                    AdrCompsetLy: null,
                    AdrIndex: null,
                    AdrIndexChange: null,
                    AdrIndexLy: null,
                    RevparMyProperty: null,
                    RevparMyPropertyChange: null,
                    RevparMyPropertyLy: null,
                    RevparCompset: null,
                    RevparCompsetChange: null,
                    RevparCompsetLy: null,
                    RevparIndex: null,
                    RevparIndexChange: null,
                    RevparIndexLy: null,
                },
                {
                    Weekday: "Monday",
                    propertyCode: para?.propertyCode,
                    AsOfDate: para?.asOfDate,
                    OccMyProperty: null,
                    OccMyPropertyChange: null,
                    OccMyPropertyLy: null,
                    OccCompset: null,
                    OccCompsetChange: null,
                    OccCompsetLy: null,
                    OccIndex: null,
                    OccIndexChange: null,
                    OccIndexLy: null,
                    AdrMyProperty: null,
                    AdrMyPropertyChange: null,
                    AdrMyPropertyLy: null,
                    AdrCompset: null,
                    AdrCompsetChange: null,
                    AdrCompsetLy: null,
                    AdrIndex: null,
                    AdrIndexChange: null,
                    AdrIndexLy: null,
                    RevparMyProperty: null,
                    RevparMyPropertyChange: null,
                    RevparMyPropertyLy: null,
                    RevparCompset: null,
                    RevparCompsetChange: null,
                    RevparCompsetLy: null,
                    RevparIndex: null,
                    RevparIndexChange: null,
                    RevparIndexLy: null,
                },
                {
                    Weekday: "Tuesday",
                    propertyCode: para?.propertyCode,
                    AsOfDate: para?.asOfDate,
                    OccMyProperty: null,
                    OccMyPropertyChange: null,
                    OccMyPropertyLy: null,
                    OccCompset: null,
                    OccCompsetChange: null,
                    OccCompsetLy: null,
                    OccIndex: null,
                    OccIndexChange: null,
                    OccIndexLy: null,
                    AdrMyProperty: null,
                    AdrMyPropertyChange: null,
                    AdrMyPropertyLy: null,
                    AdrCompset: null,
                    AdrCompsetChange: null,
                    AdrCompsetLy: null,
                    AdrIndex: null,
                    AdrIndexChange: null,
                    AdrIndexLy: null,
                    RevparMyProperty: null,
                    RevparMyPropertyChange: null,
                    RevparMyPropertyLy: null,
                    RevparCompset: null,
                    RevparCompsetChange: null,
                    RevparCompsetLy: null,
                    RevparIndex: null,
                    RevparIndexChange: null,
                    RevparIndexLy: null,
                },
                {
                    Weekday: "Wednesday",
                    propertyCode: para?.propertyCode,
                    AsOfDate: para?.asOfDate,
                    OccMyProperty: null,
                    OccMyPropertyChange: null,
                    OccMyPropertyLy: null,
                    OccCompset: null,
                    OccCompsetChange: null,
                    OccCompsetLy: null,
                    OccIndex: null,
                    OccIndexChange: null,
                    OccIndexLy: null,
                    AdrMyProperty: null,
                    AdrMyPropertyChange: null,
                    AdrMyPropertyLy: null,
                    AdrCompset: null,
                    AdrCompsetChange: null,
                    AdrCompsetLy: null,
                    AdrIndex: null,
                    AdrIndexChange: null,
                    AdrIndexLy: null,
                    RevparMyProperty: null,
                    RevparMyPropertyChange: null,
                    RevparMyPropertyLy: null,
                    RevparCompset: null,
                    RevparCompsetChange: null,
                    RevparCompsetLy: null,
                    RevparIndex: null,
                    RevparIndexChange: null,
                    RevparIndexLy: null,
                },
                {
                    Weekday: "Thursday",
                    propertyCode: para?.propertyCode,
                    AsOfDate: para?.asOfDate,
                    OccMyProperty: null,
                    OccMyPropertyChange: null,
                    OccMyPropertyLy: null,
                    OccCompset: null,
                    OccCompsetChange: null,
                    OccCompsetLy: null,
                    OccIndex: null,
                    OccIndexChange: null,
                    OccIndexLy: null,
                    AdrMyProperty: null,
                    AdrMyPropertyChange: null,
                    AdrMyPropertyLy: null,
                    AdrCompset: null,
                    AdrCompsetChange: null,
                    AdrCompsetLy: null,
                    AdrIndex: null,
                    AdrIndexChange: null,
                    AdrIndexLy: null,
                    RevparMyProperty: null,
                    RevparMyPropertyChange: null,
                    RevparMyPropertyLy: null,
                    RevparCompset: null,
                    RevparCompsetChange: null,
                    RevparCompsetLy: null,
                    RevparIndex: null,
                    RevparIndexChange: null,
                    RevparIndexLy: null,
                },
                {
                    Weekday: "Friday",
                    propertyCode: para?.propertyCode,
                    AsOfDate: para?.asOfDate,
                    OccMyProperty: null,
                    OccMyPropertyChange: null,
                    OccMyPropertyLy: null,
                    OccCompset: null,
                    OccCompsetChange: null,
                    OccCompsetLy: null,
                    OccIndex: null,
                    OccIndexChange: null,
                    OccIndexLy: null,
                    AdrMyProperty: null,
                    AdrMyPropertyChange: null,
                    AdrMyPropertyLy: null,
                    AdrCompset: null,
                    AdrCompsetChange: null,
                    AdrCompsetLy: null,
                    AdrIndex: null,
                    AdrIndexChange: null,
                    AdrIndexLy: null,
                    RevparMyProperty: null,
                    RevparMyPropertyChange: null,
                    RevparMyPropertyLy: null,
                    RevparCompset: null,
                    RevparCompsetChange: null,
                    RevparCompsetLy: null,
                    RevparIndex: null,
                    RevparIndexChange: null,
                    RevparIndexLy: null,
                },
                {
                    Weekday: "Saturday",
                    propertyCode: para?.propertyCode,
                    AsOfDate: para?.asOfDate,
                    OccMyProperty: null,
                    OccMyPropertyChange: null,
                    OccMyPropertyLy: null,
                    OccCompset: null,
                    OccCompsetChange: null,
                    OccCompsetLy: null,
                    OccIndex: null,
                    OccIndexChange: null,
                    OccIndexLy: null,
                    AdrMyProperty: null,
                    AdrMyPropertyChange: null,
                    AdrMyPropertyLy: null,
                    AdrCompset: null,
                    AdrCompsetChange: null,
                    AdrCompsetLy: null,
                    AdrIndex: null,
                    AdrIndexChange: null,
                    AdrIndexLy: null,
                    RevparMyProperty: null,
                    RevparMyPropertyChange: null,
                    RevparMyPropertyLy: null,
                    RevparCompset: null,
                    RevparCompsetChange: null,
                    RevparCompsetLy: null,
                    RevparIndex: null,
                    RevparIndexChange: null,
                    RevparIndexLy: null,
                },
                {
                    Weekday: "Total",
                    propertyCode: para?.propertyCode,
                    AsOfDate: para?.asOfDate,
                    OccMyProperty: null,
                    OccMyPropertyChange: null,
                    OccMyPropertyLy: null,
                    OccCompset: null,
                    OccCompsetChange: null,
                    OccCompsetLy: null,
                    OccIndex: null,
                    OccIndexChange: null,
                    OccIndexLy: null,
                    AdrMyProperty: null,
                    AdrMyPropertyChange: null,
                    AdrMyPropertyLy: null,
                    AdrCompset: null,
                    AdrCompsetChange: null,
                    AdrCompsetLy: null,
                    AdrIndex: null,
                    AdrIndexChange: null,
                    AdrIndexLy: null,
                    RevparMyProperty: null,
                    RevparMyPropertyChange: null,
                    RevparMyPropertyLy: null,
                    RevparCompset: null,
                    RevparCompsetChange: null,
                    RevparCompsetLy: null,
                    RevparIndex: null,
                    RevparIndexChange: null,
                    RevparIndexLy: null,
                },
            ];
            weekDayArr?.map((item, index) => {
                let findObj = dummyData?.filter((x) => x?.Weekday?.trim() === item);
                tableDataRefSecond.current[item] = findObj?.[0];
            });
            strDataRef.current = dummyData;
            setStrData(dummyData);
            // setLoading(false);
        }
    };


    const clickOutSide = (e) => {
        if (e.target.nodeName.toLowerCase() === "input") {
            return;
        }
        setClickedTr({
            mainRow: "",
            subRow: "",
            day: "",
            field: "",
        });
    };

    useEffect(() => {
        document.addEventListener("click", clickOutSide);

        return () => {
            document.removeEventListener("click", clickOutSide);
        };
    }, []);

    const [tblids, settblids] = useState({
        weeklyStr: commonService.GenerateGUID(),
    });

    useEffect(() => {
        if (api === 0) {
        } else {
            if (para?.propertyCode) {
                getWeeklyReport();
                getStrReport();
            }
        }
    }, [selectedDate, para?.propertyCode]);

    //const handleSave = async () => {
    //    setSubmitLoading(true);
    //    let newReportData = reportData?.map((item, index) => {
    //        Object.keys(item)?.map((keyItem, keyIndex) => {
    //            if (item[keyItem] === "" || item[keyItem] === undefined) {
    //                item[keyItem] = null;
    //            }
    //        });
    //        return item;
    //    });
    //    let saveResponse = await apiCall(
    //        {
    //            method: "POST",
    //            url:
    //                API_URL.BASE_API_URL.SnapShot +
    //                API_URL.STR_REPORT_REVPAK.WEEKLY_STR_SAVE,
    //            body: {
    //                // report_data: reportData,
    //                report_data: newReportData,
    //                propertyCode: para?.propertyCode,
    //            },
    //        },
    //        false
    //    );

    //    let response = apiResponse(true, saveResponse, setSubmitLoading);

    //    if (response?.isValidate) {
    //    }

    //    if (!response?.isValidate) {
    //    }
    //};

    const handleSaveAfterImport = async (newStrDate) => {
        setSubmitLoading(true);
        let newStrData = newStrDate?.map((item, index) => {
            Object.keys(item)?.map((keyItem, keyIndex) => {
                if (item[keyItem] === "" || item[keyItem] === undefined) {
                    item[keyItem] = null;
                }
            });
            return item;
        });
        let saveResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.STR_REPORT_REVPAK.RUNNING_STR_SAVE,
                body: {
                    report_data: newStrData,
                    propertyCode: para?.propertyCode,
                },
            },
            false
        );

        let response = apiResponse(false, saveResponse, setSubmitLoading);

        if (response?.isValidate) {
            getStrReport();
        }

        if (!response?.isValidate) {
        }
    };

    const handleImport = async (file) => {
        setFileImportLoading(true);
        let fileResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.STR_REPORT_REVPAK.READ_STR_ANALYSIS,
                body: {
                    file: file,
                },
            },
            true
        );

        let response = apiResponse(false, fileResponse);

        if (response?.isValidate) {
            let obj = {
                0: {
                    0: "OccMyProperty",
                    1: "OccMyPropertyChange",
                    2: "OccMyPropertyLy",
                },
                1: {
                    0: "OccCompset",
                    1: "OccCompsetChange",
                    2: "OccCompsetLy",
                },
                2: {
                    0: "OccIndex",
                    1: "OccIndexChange",
                    2: "OccIndexLy",
                },
                3: {
                    0: "AdrMyProperty",
                    1: "AdrMyPropertyChange",
                    2: "AdrMyPropertyLy",
                },
                4: {
                    0: "AdrCompset",
                    1: "AdrCompsetChange",
                    2: "AdrCompsetLy",
                },
                5: {
                    0: "AdrIndex",
                    1: "AdrIndexChange",
                    2: "AdrIndexLy",
                },
                6: {
                    0: "RevparMyProperty",
                    1: "RevparMyPropertyChange",
                    2: "RevparMyPropertyLy",
                },
                7: {
                    0: "RevparCompset",
                    1: "RevparCompsetChange",
                    2: "RevparCompsetLy",
                },
                8: {
                    0: "RevparIndex",
                    1: "RevparIndexChange",
                    2: "RevparIndexLy",
                },
            };

            let dataFromApi = [...response?.data?.data.weekly];

            let savedData = [...tableDataRef.current];

            dataFromApi?.forEach((item, index) => {
                let arrays = [],
                    size = 3;

                for (let i = 0; i < item.length; i += size) {
                    arrays.push(item.slice(i, i + size));
                }
                arrays?.forEach((nestedItem, nestedIndex) => {
                    nestedItem?.forEach((mainNestedItem, mainNestedIndex) => {
                        const value = mainNestedItem
                            ? parseFloat(mainNestedItem).toFixed(2)
                            : 0;

                        // ✅ Defensive checks
                        if (!savedData[nestedIndex]) {
                            savedData[nestedIndex] = {}; // ensure object exists
                        }

                        if (obj[index] && obj[index][mainNestedIndex]) {
                            const key = obj[index][mainNestedIndex];
                            savedData[nestedIndex][key] = value;
                        } else {
                            console.warn(
                                `Missing key mapping at obj[${index}][${mainNestedIndex}]`
                            );
                        }
                    });
                });
            });

            tableDataRef.current = savedData;
            setReportData(tableDataRef.current);
            reportDataRef.current = tableDataRef.current;
            /*let _stayEndDate = new Date(moment(stayStartDate).format("YYYY-MM-DD"));*/

            let _stayEndDate = new Date(stayStartDate);

            let newReportData = reportDataRef.current?.map((item, index) => {
                Object.keys(item)?.map((keyItem, keyIndex) => {
                    if (item[keyItem] === "" || item[keyItem] === undefined) {
                        item[keyItem] = null;
                    }
                });
                item.propertyCode = para?.propertyCode;
                item.AsOfDate = para?.asOfDate;
                if (index < 7) {
                    item.StarReportDate = moment(_stayEndDate).format("YYYY-MM-DD");
                }
                _stayEndDate = new Date(
                    _stayEndDate.setDate(_stayEndDate.getDate() + 1)
                );
                return item;
            });

            let dataFromApi1 = response?.data?.data.day28;

            if (dataFromApi1 && dataFromApi1.length === 9) {
                let _strData = [...strData];
                let Sunday = _strData.filter((i) => i.Weekday === "Sunday");
                let Monday = _strData.filter((i) => i.Weekday === "Monday");
                let Tuesday = _strData.filter((i) => i.Weekday === "Tuesday");
                let Wednesday = _strData.filter((i) => i.Weekday === "Wednesday");
                let Thursday = _strData.filter((i) => i.Weekday === "Thursday");
                let Friday = _strData.filter((i) => i.Weekday === "Friday");
                let Saturday = _strData.filter((i) => i.Weekday === "Saturday");
                let Total = _strData.filter((i) => i.Weekday === "Total");

                if (
                    Sunday &&
                    Monday &&
                    Tuesday &&
                    Wednesday &&
                    Thursday &&
                    Friday &&
                    Saturday &&
                    Total
                ) {
                    if (
                        Sunday.length > 0 &&
                        Monday.length > 0 &&
                        Tuesday.length > 0 &&
                        Wednesday.length > 0 &&
                        Thursday.length > 0 &&
                        Friday.length > 0 &&
                        Saturday.length > 0 &&
                        Total.length > 0
                    ) {
                        //Occ Start
                        Sunday[0].OccMyProperty = parseFloat(dataFromApi1[0][0])?.toFixed(
                            2
                        );
                        Sunday[0].OccMyPropertyChange = parseFloat(
                            dataFromApi1[0][1]
                        )?.toFixed(2);
                        Sunday[0].OccMyPropertyLy = parseFloat(dataFromApi1[0][2])?.toFixed(
                            2
                        );

                        Monday[0].OccMyProperty = parseFloat(dataFromApi1[0][3])?.toFixed(
                            2
                        );
                        Monday[0].OccMyPropertyChange = parseFloat(
                            dataFromApi1[0][4]
                        )?.toFixed(2);
                        Monday[0].OccMyPropertyLy = parseFloat(dataFromApi1[0][5])?.toFixed(
                            2
                        );

                        Tuesday[0].OccMyProperty = parseFloat(dataFromApi1[0][6])?.toFixed(
                            2
                        );
                        Tuesday[0].OccMyPropertyChange = parseFloat(
                            dataFromApi1[0][7]
                        )?.toFixed(2);
                        Tuesday[0].OccMyPropertyLy = parseFloat(
                            dataFromApi1[0][8]
                        )?.toFixed(2);

                        Wednesday[0].OccMyProperty = parseFloat(
                            dataFromApi1[0][9]
                        )?.toFixed(2);
                        Wednesday[0].OccMyPropertyChange = parseFloat(
                            dataFromApi1[0][10]
                        )?.toFixed(2);
                        Wednesday[0].OccMyPropertyLy = parseFloat(
                            dataFromApi1[0][11]
                        )?.toFixed(2);

                        Thursday[0].OccMyProperty = parseFloat(
                            dataFromApi1[0][12]
                        )?.toFixed(2);
                        Thursday[0].OccMyPropertyChange = parseFloat(
                            dataFromApi1[0][13]
                        )?.toFixed(2);
                        Thursday[0].OccMyPropertyLy = parseFloat(
                            dataFromApi1[0][14]
                        )?.toFixed(2);

                        Friday[0].OccMyProperty = parseFloat(dataFromApi1[0][15])?.toFixed(
                            2
                        );
                        Friday[0].OccMyPropertyChange = parseFloat(
                            dataFromApi1[0][16]
                        )?.toFixed(2);
                        Friday[0].OccMyPropertyLy = parseFloat(
                            dataFromApi1[0][17]
                        )?.toFixed(2);

                        Saturday[0].OccMyProperty = parseFloat(
                            dataFromApi1[0][18]
                        )?.toFixed(2);
                        Saturday[0].OccMyPropertyChange = parseFloat(
                            dataFromApi1[0][19]
                        )?.toFixed(2);
                        Saturday[0].OccMyPropertyLy = parseFloat(
                            dataFromApi1[0][20]
                        )?.toFixed(2);

                        Total[0].OccMyProperty = parseFloat(dataFromApi1[0][21])?.toFixed(
                            2
                        );
                        Total[0].OccMyPropertyChange = parseFloat(
                            dataFromApi1[0][22]
                        )?.toFixed(2);
                        Total[0].OccMyPropertyLy = parseFloat(dataFromApi1[0][23])?.toFixed(
                            2
                        );

                        Sunday[0].OccCompset = parseFloat(dataFromApi1[1][0])?.toFixed(2);
                        Sunday[0].OccCompsetChange = parseFloat(
                            dataFromApi1[1][1]
                        )?.toFixed(2);
                        Sunday[0].OccCompsetLy = parseFloat(dataFromApi1[1][2])?.toFixed(2);

                        Monday[0].OccCompset = parseFloat(dataFromApi1[1][3])?.toFixed(2);
                        Monday[0].OccCompsetChange = parseFloat(
                            dataFromApi1[1][4]
                        )?.toFixed(2);
                        Monday[0].OccCompsetLy = parseFloat(dataFromApi1[1][5])?.toFixed(2);

                        Tuesday[0].OccCompset = parseFloat(dataFromApi1[1][6])?.toFixed(2);
                        Tuesday[0].OccCompsetChange = parseFloat(
                            dataFromApi1[1][7]
                        )?.toFixed(2);
                        Tuesday[0].OccCompsetLy = parseFloat(dataFromApi1[1][8])?.toFixed(
                            2
                        );

                        Wednesday[0].OccCompset = parseFloat(dataFromApi1[1][9])?.toFixed(
                            2
                        );
                        Wednesday[0].OccCompsetChange = parseFloat(
                            dataFromApi1[1][10]
                        )?.toFixed(2);
                        Wednesday[0].OccCompsetLy = parseFloat(
                            dataFromApi1[1][11]
                        )?.toFixed(2);

                        Thursday[0].OccCompset = parseFloat(dataFromApi1[1][12])?.toFixed(
                            2
                        );
                        Thursday[0].OccCompsetChange = parseFloat(
                            dataFromApi1[1][13]
                        )?.toFixed(2);
                        Thursday[0].OccCompsetLy = parseFloat(dataFromApi1[1][14])?.toFixed(
                            2
                        );

                        Friday[0].OccCompset = parseFloat(dataFromApi1[1][15])?.toFixed(2);
                        Friday[0].OccCompsetChange = parseFloat(
                            dataFromApi1[1][16]
                        )?.toFixed(2);
                        Friday[0].OccCompsetLy = parseFloat(dataFromApi1[1][17])?.toFixed(
                            2
                        );

                        Saturday[0].OccCompset = parseFloat(dataFromApi1[1][18])?.toFixed(
                            2
                        );
                        Saturday[0].OccCompsetChange = parseFloat(
                            dataFromApi1[1][19]
                        )?.toFixed(2);
                        Saturday[0].OccCompsetLy = parseFloat(dataFromApi1[1][20])?.toFixed(
                            2
                        );

                        Total[0].OccCompset = parseFloat(dataFromApi1[1][21])?.toFixed(2);
                        Total[0].OccCompsetChange = parseFloat(
                            dataFromApi1[1][22]
                        )?.toFixed(2);
                        Total[0].OccCompsetLy = parseFloat(dataFromApi1[1][23])?.toFixed(2);

                        Sunday[0].OccIndex = parseFloat(dataFromApi1[2][0])?.toFixed(2);
                        Sunday[0].OccIndexChange = parseFloat(dataFromApi1[2][1])?.toFixed(
                            2
                        );
                        Sunday[0].OccIndexLy = parseFloat(dataFromApi1[2][2])?.toFixed(2);

                        Monday[0].OccIndex = parseFloat(dataFromApi1[2][3])?.toFixed(2);
                        Monday[0].OccIndexChange = parseFloat(dataFromApi1[2][4])?.toFixed(
                            2
                        );
                        Monday[0].OccIndexLy = parseFloat(dataFromApi1[2][5])?.toFixed(2);

                        Tuesday[0].OccIndex = parseFloat(dataFromApi1[2][6])?.toFixed(2);
                        Tuesday[0].OccIndexChange = parseFloat(dataFromApi1[2][7])?.toFixed(
                            2
                        );
                        Tuesday[0].OccIndexLy = parseFloat(dataFromApi1[2][8])?.toFixed(2);

                        Wednesday[0].OccIndex = parseFloat(dataFromApi1[2][9])?.toFixed(2);
                        Wednesday[0].OccIndexChange = parseFloat(
                            dataFromApi1[2][10]
                        )?.toFixed(2);
                        Wednesday[0].OccIndexLy = parseFloat(dataFromApi1[2][11])?.toFixed(
                            2
                        );

                        Thursday[0].OccIndex = parseFloat(dataFromApi1[2][12])?.toFixed(2);
                        Thursday[0].OccIndexChange = parseFloat(
                            dataFromApi1[2][13]
                        )?.toFixed(2);
                        Thursday[0].OccIndexLy = parseFloat(dataFromApi1[2][14])?.toFixed(
                            2
                        );

                        Friday[0].OccIndex = parseFloat(dataFromApi1[2][15])?.toFixed(2);
                        Friday[0].OccIndexChange = parseFloat(dataFromApi1[2][16])?.toFixed(
                            2
                        );
                        Friday[0].OccIndexLy = parseFloat(dataFromApi1[2][17])?.toFixed(2);

                        Saturday[0].OccIndex = parseFloat(dataFromApi1[2][18])?.toFixed(2);
                        Saturday[0].OccIndexChange = parseFloat(
                            dataFromApi1[2][19]
                        )?.toFixed(2);
                        Saturday[0].OccIndexLy = parseFloat(dataFromApi1[2][20])?.toFixed(
                            2
                        );

                        Total[0].OccIndex = parseFloat(dataFromApi1[2][21])?.toFixed(2);
                        Total[0].OccIndexChange = parseFloat(dataFromApi1[2][22])?.toFixed(
                            2
                        );
                        Total[0].OccIndexLy = parseFloat(dataFromApi1[2][23])?.toFixed(2);

                        //Occ End

                        //ADR Start
                        Sunday[0].AdrMyProperty = parseFloat(dataFromApi1[3][0])?.toFixed(
                            2
                        );
                        Sunday[0].AdrMyPropertyChange = parseFloat(
                            dataFromApi1[3][1]
                        )?.toFixed(2);
                        Sunday[0].AdrMyPropertyLy = parseFloat(dataFromApi1[3][2])?.toFixed(
                            2
                        );

                        Monday[0].AdrMyProperty = parseFloat(dataFromApi1[3][3])?.toFixed(
                            2
                        );
                        Monday[0].AdrMyPropertyChange = parseFloat(
                            dataFromApi1[3][4]
                        )?.toFixed(2);
                        Monday[0].AdrMyPropertyLy = parseFloat(dataFromApi1[3][5])?.toFixed(
                            2
                        );

                        Tuesday[0].AdrMyProperty = parseFloat(dataFromApi1[3][6])?.toFixed(
                            2
                        );
                        Tuesday[0].AdrMyPropertyChange = parseFloat(
                            dataFromApi1[3][7]
                        )?.toFixed(2);
                        Tuesday[0].AdrMyPropertyLy = parseFloat(
                            dataFromApi1[3][8]
                        )?.toFixed(2);

                        Wednesday[0].AdrMyProperty = parseFloat(
                            dataFromApi1[3][9]
                        )?.toFixed(2);
                        Wednesday[0].AdrMyPropertyChange = parseFloat(
                            dataFromApi1[3][10]
                        )?.toFixed(2);
                        Wednesday[0].AdrMyPropertyLy = parseFloat(
                            dataFromApi1[3][11]
                        )?.toFixed(2);

                        Thursday[0].AdrMyProperty = parseFloat(
                            dataFromApi1[3][12]
                        )?.toFixed(2);
                        Thursday[0].AdrMyPropertyChange = parseFloat(
                            dataFromApi1[3][13]
                        )?.toFixed(2);
                        Thursday[0].AdrMyPropertyLy = parseFloat(
                            dataFromApi1[3][14]
                        )?.toFixed(2);

                        Friday[0].AdrMyProperty = parseFloat(dataFromApi1[3][15])?.toFixed(
                            2
                        );
                        Friday[0].AdrMyPropertyChange = parseFloat(
                            dataFromApi1[3][16]
                        )?.toFixed(2);
                        Friday[0].AdrMyPropertyLy = parseFloat(
                            dataFromApi1[3][17]
                        )?.toFixed(2);

                        Saturday[0].AdrMyProperty = parseFloat(
                            dataFromApi1[3][18]
                        )?.toFixed(2);
                        Saturday[0].AdrMyPropertyChange = parseFloat(
                            dataFromApi1[3][19]
                        )?.toFixed(2);
                        Saturday[0].AdrMyPropertyLy = parseFloat(
                            dataFromApi1[3][20]
                        )?.toFixed(2);

                        Total[0].AdrMyProperty = parseFloat(dataFromApi1[3][21])?.toFixed(
                            2
                        );
                        Total[0].AdrMyPropertyChange = parseFloat(
                            dataFromApi1[3][22]
                        )?.toFixed(2);
                        Total[0].AdrMyPropertyLy = parseFloat(dataFromApi1[3][23])?.toFixed(
                            2
                        );

                        Sunday[0].AdrCompset = parseFloat(dataFromApi1[4][0])?.toFixed(2);
                        Sunday[0].AdrCompsetChange = parseFloat(
                            dataFromApi1[4][1]
                        )?.toFixed(2);
                        Sunday[0].AdrCompsetLy = parseFloat(dataFromApi1[4][2])?.toFixed(2);

                        Monday[0].AdrCompset = parseFloat(dataFromApi1[4][3])?.toFixed(2);
                        Monday[0].AdrCompsetChange = parseFloat(
                            dataFromApi1[4][4]
                        )?.toFixed(2);
                        Monday[0].AdrCompsetLy = parseFloat(dataFromApi1[4][5])?.toFixed(2);

                        Tuesday[0].AdrCompset = parseFloat(dataFromApi1[4][6])?.toFixed(2);
                        Tuesday[0].AdrCompsetChange = parseFloat(
                            dataFromApi1[4][7]
                        )?.toFixed(2);
                        Tuesday[0].AdrCompsetLy = parseFloat(dataFromApi1[4][8])?.toFixed(
                            2
                        );

                        Wednesday[0].AdrCompset = parseFloat(dataFromApi1[4][9])?.toFixed(
                            2
                        );
                        Wednesday[0].AdrCompsetChange = parseFloat(
                            dataFromApi1[4][10]
                        )?.toFixed(2);
                        Wednesday[0].AdrCompsetLy = parseFloat(
                            dataFromApi1[4][11]
                        )?.toFixed(2);

                        Thursday[0].AdrCompset = parseFloat(dataFromApi1[4][12])?.toFixed(
                            2
                        );
                        Thursday[0].AdrCompsetChange = parseFloat(
                            dataFromApi1[4][13]
                        )?.toFixed(2);
                        Thursday[0].AdrCompsetLy = parseFloat(dataFromApi1[4][14])?.toFixed(
                            2
                        );

                        Friday[0].AdrCompset = parseFloat(dataFromApi1[4][15])?.toFixed(2);
                        Friday[0].AdrCompsetChange = parseFloat(
                            dataFromApi1[4][16]
                        )?.toFixed(2);
                        Friday[0].AdrCompsetLy = parseFloat(dataFromApi1[4][17])?.toFixed(
                            2
                        );

                        Saturday[0].AdrCompset = parseFloat(dataFromApi1[4][18])?.toFixed(
                            2
                        );
                        Saturday[0].AdrCompsetChange = parseFloat(
                            dataFromApi1[4][19]
                        )?.toFixed(2);
                        Saturday[0].AdrCompsetLy = parseFloat(dataFromApi1[4][20])?.toFixed(
                            2
                        );

                        Total[0].AdrCompset = parseFloat(dataFromApi1[4][21])?.toFixed(2);
                        Total[0].AdrCompsetChange = parseFloat(
                            dataFromApi1[4][22]
                        )?.toFixed(2);
                        Total[0].AdrCompsetLy = parseFloat(dataFromApi1[4][23])?.toFixed(2);

                        Sunday[0].AdrIndex = parseFloat(dataFromApi1[5][0])?.toFixed(2);
                        Sunday[0].AdrIndexChange = parseFloat(dataFromApi1[5][1])?.toFixed(
                            2
                        );
                        Sunday[0].AdrIndexLy = parseFloat(dataFromApi1[5][2])?.toFixed(2);

                        Monday[0].AdrIndex = parseFloat(dataFromApi1[5][3])?.toFixed(2);
                        Monday[0].AdrIndexChange = parseFloat(dataFromApi1[5][4])?.toFixed(
                            2
                        );
                        Monday[0].AdrIndexLy = parseFloat(dataFromApi1[5][5])?.toFixed(2);

                        Tuesday[0].AdrIndex = parseFloat(dataFromApi1[5][6])?.toFixed(2);
                        Tuesday[0].AdrIndexChange = parseFloat(dataFromApi1[5][7])?.toFixed(
                            2
                        );
                        Tuesday[0].AdrIndexLy = parseFloat(dataFromApi1[5][8])?.toFixed(2);

                        Wednesday[0].AdrIndex = parseFloat(dataFromApi1[5][9])?.toFixed(2);
                        Wednesday[0].AdrIndexChange = parseFloat(
                            dataFromApi1[5][10]
                        )?.toFixed(2);
                        Wednesday[0].AdrIndexLy = parseFloat(dataFromApi1[5][11])?.toFixed(
                            2
                        );

                        Thursday[0].AdrIndex = parseFloat(dataFromApi1[5][12])?.toFixed(2);
                        Thursday[0].AdrIndexChange = parseFloat(
                            dataFromApi1[5][13]
                        )?.toFixed(2);
                        Thursday[0].AdrIndexLy = parseFloat(dataFromApi1[5][14])?.toFixed(
                            2
                        );

                        Friday[0].AdrIndex = parseFloat(dataFromApi1[5][15])?.toFixed(2);
                        Friday[0].AdrIndexChange = parseFloat(dataFromApi1[5][16])?.toFixed(
                            2
                        );
                        Friday[0].AdrIndexLy = parseFloat(dataFromApi1[5][17])?.toFixed(2);

                        Saturday[0].AdrIndex = parseFloat(dataFromApi1[5][18])?.toFixed(2);
                        Saturday[0].AdrIndexChange = parseFloat(
                            dataFromApi1[5][19]
                        )?.toFixed(2);
                        Saturday[0].AdrIndexLy = parseFloat(dataFromApi1[5][20])?.toFixed(
                            2
                        );

                        Total[0].AdrIndex = parseFloat(dataFromApi1[5][21])?.toFixed(2);
                        Total[0].AdrIndexChange = parseFloat(dataFromApi1[5][22])?.toFixed(
                            2
                        );
                        Total[0].AdrIndexLy = parseFloat(dataFromApi1[5][23])?.toFixed(2);

                        //ADR End

                        //RevPAR Start
                        Sunday[0].RevparMyProperty = parseFloat(
                            dataFromApi1[6][0]
                        )?.toFixed(2);
                        Sunday[0].RevparMyPropertyChange = parseFloat(
                            dataFromApi1[6][1]
                        )?.toFixed(2);
                        Sunday[0].RevparMyPropertyLy = parseFloat(
                            dataFromApi1[6][2]
                        )?.toFixed(2);

                        Monday[0].RevparMyProperty = parseFloat(
                            dataFromApi1[6][3]
                        )?.toFixed(2);
                        Monday[0].RevparMyPropertyChange = parseFloat(
                            dataFromApi1[6][4]
                        )?.toFixed(2);
                        Monday[0].RevparMyPropertyLy = parseFloat(
                            dataFromApi1[6][5]
                        )?.toFixed(2);

                        Tuesday[0].RevparMyProperty = parseFloat(
                            dataFromApi1[6][6]
                        )?.toFixed(2);
                        Tuesday[0].RevparMyPropertyChange = parseFloat(
                            dataFromApi1[6][7]
                        )?.toFixed(2);
                        Tuesday[0].RevparMyPropertyLy = parseFloat(
                            dataFromApi1[6][8]
                        )?.toFixed(2);

                        Wednesday[0].RevparMyProperty = parseFloat(
                            dataFromApi1[6][9]
                        )?.toFixed(2);
                        Wednesday[0].RevparMyPropertyChange = parseFloat(
                            dataFromApi1[6][10]
                        )?.toFixed(2);
                        Wednesday[0].RevparMyPropertyLy = parseFloat(
                            dataFromApi1[6][11]
                        )?.toFixed(2);

                        Thursday[0].RevparMyProperty = parseFloat(
                            dataFromApi1[6][12]
                        )?.toFixed(2);
                        Thursday[0].RevparMyPropertyChange = parseFloat(
                            dataFromApi1[6][13]
                        )?.toFixed(2);
                        Thursday[0].RevparMyPropertyLy = parseFloat(
                            dataFromApi1[6][14]
                        )?.toFixed(2);

                        Friday[0].RevparMyProperty = parseFloat(
                            dataFromApi1[6][15]
                        )?.toFixed(2);
                        Friday[0].RevparMyPropertyChange = parseFloat(
                            dataFromApi1[6][16]
                        )?.toFixed(2);
                        Friday[0].RevparMyPropertyLy = parseFloat(
                            dataFromApi1[6][17]
                        )?.toFixed(2);

                        Saturday[0].RevparMyProperty = parseFloat(
                            dataFromApi1[6][18]
                        )?.toFixed(2);
                        Saturday[0].RevparMyPropertyChange = parseFloat(
                            dataFromApi1[6][19]
                        )?.toFixed(2);
                        Saturday[0].RevparMyPropertyLy = parseFloat(
                            dataFromApi1[6][20]
                        )?.toFixed(2);

                        Total[0].RevparMyProperty = parseFloat(
                            dataFromApi1[6][21]
                        )?.toFixed(2);
                        Total[0].RevparMyPropertyChange = parseFloat(
                            dataFromApi1[6][22]
                        )?.toFixed(2);
                        Total[0].RevparMyPropertyLy = parseFloat(
                            dataFromApi1[6][23]
                        )?.toFixed(2);

                        Sunday[0].RevparCompset = parseFloat(dataFromApi1[7][0])?.toFixed(
                            2
                        );
                        Sunday[0].RevparCompsetChange = parseFloat(
                            dataFromApi1[7][1]
                        )?.toFixed(2);
                        Sunday[0].RevparCompsetLy = parseFloat(dataFromApi1[7][2])?.toFixed(
                            2
                        );

                        Monday[0].RevparCompset = parseFloat(dataFromApi1[7][3])?.toFixed(
                            2
                        );
                        Monday[0].RevparCompsetChange = parseFloat(
                            dataFromApi1[7][4]
                        )?.toFixed(2);
                        Monday[0].RevparCompsetLy = parseFloat(dataFromApi1[7][5])?.toFixed(
                            2
                        );

                        Tuesday[0].RevparCompset = parseFloat(dataFromApi1[7][6])?.toFixed(
                            2
                        );
                        Tuesday[0].RevparCompsetChange = parseFloat(
                            dataFromApi1[7][7]
                        )?.toFixed(2);
                        Tuesday[0].RevparCompsetLy = parseFloat(
                            dataFromApi1[7][8]
                        )?.toFixed(2);

                        Wednesday[0].RevparCompset = parseFloat(
                            dataFromApi1[7][9]
                        )?.toFixed(2);
                        Wednesday[0].RevparCompsetChange = parseFloat(
                            dataFromApi1[7][10]
                        )?.toFixed(2);
                        Wednesday[0].RevparCompsetLy = parseFloat(
                            dataFromApi1[7][11]
                        )?.toFixed(2);

                        Thursday[0].RevparCompset = parseFloat(
                            dataFromApi1[7][12]
                        )?.toFixed(2);
                        Thursday[0].RevparCompsetChange = parseFloat(
                            dataFromApi1[7][13]
                        )?.toFixed(2);
                        Thursday[0].RevparCompsetLy = parseFloat(
                            dataFromApi1[7][14]
                        )?.toFixed(2);

                        Friday[0].RevparCompset = parseFloat(dataFromApi1[7][15])?.toFixed(
                            2
                        );
                        Friday[0].RevparCompsetChange = parseFloat(
                            dataFromApi1[7][16]
                        )?.toFixed(2);
                        Friday[0].RevparCompsetLy = parseFloat(
                            dataFromApi1[7][17]
                        )?.toFixed(2);

                        Saturday[0].RevparCompset = parseFloat(
                            dataFromApi1[7][18]
                        )?.toFixed(2);
                        Saturday[0].RevparCompsetChange = parseFloat(
                            dataFromApi1[7][19]
                        )?.toFixed(2);
                        Saturday[0].RevparCompsetLy = parseFloat(
                            dataFromApi1[7][20]
                        )?.toFixed(2);

                        Total[0].RevparCompset = parseFloat(dataFromApi1[7][21])?.toFixed(
                            2
                        );
                        Total[0].RevparCompsetChange = parseFloat(
                            dataFromApi1[7][22]
                        )?.toFixed(2);
                        Total[0].RevparCompsetLy = parseFloat(dataFromApi1[7][23])?.toFixed(
                            2
                        );

                        Sunday[0].RevparIndex = parseFloat(dataFromApi1[8][0])?.toFixed(2);
                        Sunday[0].RevparIndexChange = parseFloat(
                            dataFromApi1[8][1]
                        )?.toFixed(2);
                        Sunday[0].RevparIndexLy = parseFloat(dataFromApi1[8][2])?.toFixed(
                            2
                        );
                        Sunday[0].StarReportDate = stayStartDate
                            ? commonService.getDateForNode(stayStartDate)
                            : "";

                        Monday[0].RevparIndex = parseFloat(dataFromApi1[8][3])?.toFixed(2);
                        Monday[0].RevparIndexChange = parseFloat(
                            dataFromApi1[8][4]
                        )?.toFixed(2);
                        Monday[0].RevparIndexLy = parseFloat(dataFromApi1[8][5])?.toFixed(
                            2
                        );
                        Monday[0].StarReportDate = stayStartDate
                            ? commonService.getDateForNode(stayStartDate)
                            : "";

                        Tuesday[0].RevparIndex = parseFloat(dataFromApi1[8][6])?.toFixed(2);
                        Tuesday[0].RevparIndexChange = parseFloat(
                            dataFromApi1[8][7]
                        )?.toFixed(2);
                        Tuesday[0].RevparIndexLy = parseFloat(dataFromApi1[8][8])?.toFixed(
                            2
                        );
                        Tuesday[0].StarReportDate = stayStartDate
                            ? commonService.getDateForNode(stayStartDate)
                            : "";

                        Wednesday[0].RevparIndex = parseFloat(dataFromApi1[8][9])?.toFixed(
                            2
                        );
                        Wednesday[0].RevparIndexChange = parseFloat(
                            dataFromApi1[8][10]
                        )?.toFixed(2);
                        Wednesday[0].RevparIndexLy = parseFloat(
                            dataFromApi1[8][11]
                        )?.toFixed(2);
                        Wednesday[0].StarReportDate = stayStartDate
                            ? commonService.getDateForNode(stayStartDate)
                            : "";

                        Thursday[0].RevparIndex = parseFloat(dataFromApi1[8][12])?.toFixed(
                            2
                        );
                        Thursday[0].RevparIndexChange = parseFloat(
                            dataFromApi1[8][13]
                        )?.toFixed(2);
                        Thursday[0].RevparIndexLy = parseFloat(
                            dataFromApi1[8][14]
                        )?.toFixed(2);
                        Thursday[0].StarReportDate = stayStartDate
                            ? commonService.getDateForNode(stayStartDate)
                            : "";

                        Friday[0].RevparIndex = parseFloat(dataFromApi1[8][15])?.toFixed(2);
                        Friday[0].RevparIndexChange = parseFloat(
                            dataFromApi1[8][16]
                        )?.toFixed(2);
                        Friday[0].RevparIndexLy = parseFloat(dataFromApi1[8][17])?.toFixed(
                            2
                        );
                        Friday[0].StarReportDate = stayStartDate
                            ? commonService.getDateForNode(stayStartDate)
                            : "";

                        Saturday[0].RevparIndex = parseFloat(dataFromApi1[8][18])?.toFixed(
                            2
                        );
                        Saturday[0].RevparIndexChange = parseFloat(
                            dataFromApi1[8][19]
                        )?.toFixed(2);
                        Saturday[0].RevparIndexLy = parseFloat(
                            dataFromApi1[8][20]
                        )?.toFixed(2);
                        Saturday[0].StarReportDate = stayStartDate
                            ? commonService.getDateForNode(stayStartDate)
                            : "";

                        Total[0].RevparIndex = parseFloat(dataFromApi1[8][21])?.toFixed(2);
                        Total[0].RevparIndexChange = parseFloat(
                            dataFromApi1[8][22]
                        )?.toFixed(2);
                        Total[0].RevparIndexLy = parseFloat(dataFromApi1[8][23])?.toFixed(
                            2
                        );
                        Total[0].StarReportDate = stayStartDate
                            ? commonService.getDateForNode(stayStartDate)
                            : "";

                        //RevPAR End

                        let dummyData = [];
                        dummyData.push(Sunday[0]);
                        dummyData.push(Monday[0]);
                        dummyData.push(Tuesday[0]);
                        dummyData.push(Wednesday[0]);
                        dummyData.push(Thursday[0]);
                        dummyData.push(Friday[0]);
                        dummyData.push(Saturday[0]);
                        dummyData.push(Total[0]);
                        strDataRef.current = dummyData;
                        setStrData(dummyData);
                        handleSaveAfterImport(dummyData);
                    }
                }
            }

            let saveResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot +
                        API_URL.STR_REPORT_REVPAK.WEEKLY_STR_SAVE,
                    body: {
                        report_data: newReportData,
                        propertyCode: para?.propertyCode,
                    },
                },
                false
            );

            let savingresponse = apiResponse(false, saveResponse, setSubmitLoading);

            if (savingresponse?.isValidate) {
            }

            if (!savingresponse?.isValidate) {
            }


            let ARCHIVEDATAFILE_SAVE = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASE_API_URL.Notification + API_URL.ARCHIVE.ARCHIVEDATAFILE_SAVE,
                    body: {
                        asofdate: commonService.getDateInDBFormat(stayEndDate),
                        propertycode: para?.propertyCode,
                        archivetype: "STAR Report",
                        archivefile: file,
                        createdby: userDetails?.userid ? userDetails?.userid : 0
                    },
                },
                true
            );

            let ARCHIVEDATAFILE_SAVEresponse = apiResponse(true, ARCHIVEDATAFILE_SAVE, setSubmitLoading);
        }

        setFileImportLoading(false);

        inputFile.current.value = "";
        inputFile.current.type = "text";
        inputFile.current.type = "file";
    };

    return (
        <>
            <div className="widget-container" style={{ position: "relative" }}>
                <div className="weekly-report-div mb-3">
                    <div className="form-groups from-groups no-border-break meghaDatePicker width225">
                        <DatePicker id={commonService.generateGlobalClickTrackerID("WeeklyStar", "datepicker-onchange", propertyCode)}
                            portalId="datepicker-root"
                            onChange={handleStayDateChange}
                            startDate={stayStartDate}
                            endDate={stayEndDate}
                            selectsRange
                            monthsShown={2}
                            open={isOpen}
                            onClickOutside={() => setIsOpen(false)}
                            onInputClick={() => setIsOpen(true)}
                        />
                    </div>

                    <div className="weekly-report-heading">
                        <p>{`${commonService.getDateInFormat(
                            stayStartDate
                        )} - ${commonService.getDateInFormat(stayEndDate)}`}</p>
                    </div>
                    <div>
                        <div
                            className={`special-btn-input-type-file ${fileImportLoading ? "disable-special-btn-input-type-file" : ""
                                }`}
                        >
                            <input id={commonService.generateGlobalClickTrackerID("WeeklyStar", "input-onchange", propertyCode)}
                                ref={inputFile}
                                type="file"
                                accept=".xlsx,.xls"
                                onChange={(e) => {
                                    if (e?.target?.files?.[0]) {
                                        handleImport(e?.target?.files?.[0]);
                                    }
                                }}
                                disabled={fileImportLoading}
                            />
                        </div>
                    </div>
                </div>
                {api !== 0 && (
                    <div
                        className="gap-1 widget-container-menu"
                        style={{ right: "70px" }}
                    >
                        <Button
                            className="heading-menu-btns"
                            type="button"
                            title="Send Mail"
                        >
                            <img id={commonService.generateGlobalClickTrackerID("WeeklyStar", "emailicon", propertyCode)}
                                src={emailIcon}
                                alt="emailIcon"
                                onClick={() => {
                                    commonService.fnSendWidgetMail(
                                        tblids.weeklyStr,
                                        "Weekly Report",
                                        snapshotId,
                                        defaultAsOfDateFromRTK,
                                        "",
                                        para?.widgetId
                                    );
                                }}
                            />
                        </Button>
                        <Button className="heading-menu-btns" type="button">
                            <img id={commonService.generateGlobalClickTrackerID("WeeklyStar", "info", propertyCode)}
                                src={infoIcon}
                                alt="info"
                                onClick={() => {
                                    widgetDetailRef.current = {
                                        widgetdetails: "",
                                        usernote: "",
                                        compName: compName?.weeklyStrReport,
                                        widgetId: para?.widgetId,
                                    };
                                    setWidgetModal(true);
                                }}
                            />
                        </Button>
                        <Button className="heading-menu-btns" type="button">
                            <img id={commonService.generateGlobalClickTrackerID("WeeklyStar", "menuicon", propertyCode)}
                                src={downloadIcon}
                                alt="menuIcon"
                                import={tblids.weeklyStr}
                                onClick={() =>
                                    commonService.fnExportInCSV(
                                        tblids.weeklyStr,
                                        `${para?.propertyCode}-Weekly Report-${moment(
                                            new Date()
                                        ).format("MMDDYYYY")}`
                                    )
                                }
                            />
                        </Button>
                    </div>
                )}

                <div className="ViewPropertySetupTable">
                    <div className="stripped__table table-responsive">
                        <Table id={tblids.weeklyStr} responsive>
                            <thead>
                                <tr>
                                    <th className="border_right width50"></th>
                                    <th className="border_right width90"></th>
                                    {dayNames?.map((item, index) => {
                                        return (
                                            <th
                                                className="border_right text-center width50"
                                                key={`${item}firstth`}
                                                colSpan={3}
                                            >
                                                {item}
                                            </th>
                                        );
                                    })}
                                    <th colSpan={2} className="text-center width50">Total</th>
                                    {/* <th className="width50"></th> */}
                                </tr>
                                <tr>
                                    <th className="border_right"></th>
                                    <th className="border_right"></th>
                                    {dayNames?.map((item, index) => {
                                        return (
                                            <React.Fragment key={`${item}secondth`}>
                                                <th className="width50"></th>
                                                <th className="width50">%Chg</th>
                                                <th className="border_right width50">LY</th>
                                            </React.Fragment>
                                        );
                                    })}
                                    <th className="width50">AVG</th>
                                    <th className="width50">%CHG</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr style={{ height: "80px", position: "relative" }}>
                                        <Loader />
                                    </tr>
                                ) : reportData ? (
                                    <>
                                        <tr className="shadowOnHover">
                                            <td rowSpan={3} className="th-with-rowspan border_right">
                                                Occupancy
                                            </td>
                                            <td className="border_right">My Property (%)</td>
                                            <td>
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "sunday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "total-avg", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[0]?.OccMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 0) {
                                                                        item.OccMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccMyPropertyChange
                                                                            ? parseFloat(item.OccMyPropertyChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[0].OccMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[0].OccMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[0]?.OccMyProperty ? (
                                                    tableDataRef.current[0]?.OccMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td>
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "sunday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "total-chg", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[0]?.OccMyPropertyChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 0) {
                                                                        item.OccMyPropertyChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccMyProperty
                                                                            ? parseFloat(item.OccMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[0].OccMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[0].OccMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[0]?.OccMyPropertyChange ? (
                                                    tableDataRef.current[0]?.OccMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[0]?.OccMyPropertyLy
                                                    ? tableDataRef.current[0]?.OccMyPropertyLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "monday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "monday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[1]?.OccMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 1) {
                                                                        item.OccMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccMyPropertyChange
                                                                            ? parseFloat(item.OccMyPropertyChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[1].OccMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[1].OccMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[1]?.OccMyProperty ? (
                                                    tableDataRef.current[1]?.OccMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "monday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "monday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[1]?.OccMyPropertyChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 1) {
                                                                        item.OccMyPropertyChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccMyProperty
                                                                            ? parseFloat(item.OccMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[1].OccMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[1].OccMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[1]?.OccMyPropertyChange ? (
                                                    tableDataRef.current[1]?.OccMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[1]?.OccMyPropertyLy
                                                    ? tableDataRef.current[1]?.OccMyPropertyLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "tuseday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "tuseday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[2]?.OccMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 2) {
                                                                        item.OccMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccMyPropertyChange
                                                                            ? parseFloat(item.OccMyPropertyChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[2].OccMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[2].OccMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[2]?.OccMyProperty ? (
                                                    tableDataRef.current[2]?.OccMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "tuesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "tuesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[2]?.OccMyPropertyChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 2) {
                                                                        item.OccMyPropertyChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccMyProperty
                                                                            ? parseFloat(item.OccMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[2].OccMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[2].OccMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[2]?.OccMyPropertyChange ? (
                                                    tableDataRef.current[2]?.OccMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[2]?.OccMyPropertyLy
                                                    ? tableDataRef.current[2]?.OccMyPropertyLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "wednesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "wednesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[3]?.OccMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 3) {
                                                                        item.OccMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccMyPropertyChange
                                                                            ? parseFloat(item.OccMyPropertyChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[3].OccMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[3].OccMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[3]?.OccMyProperty ? (
                                                    tableDataRef.current[3]?.OccMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "wednesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "wednesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[3]?.OccMyPropertyChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 3) {
                                                                        item.OccMyPropertyChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccMyProperty
                                                                            ? parseFloat(item.OccMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[3].OccMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[3].OccMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[3]?.OccMyPropertyChange ? (
                                                    tableDataRef.current[3]?.OccMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[3]?.OccMyPropertyLy
                                                    ? tableDataRef.current[3]?.OccMyPropertyLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "thursday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "thursday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[4]?.OccMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 4) {
                                                                        item.OccMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccMyPropertyChange
                                                                            ? parseFloat(item.OccMyPropertyChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[4].OccMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[4].OccMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[4]?.OccMyProperty ? (
                                                    tableDataRef.current[4]?.OccMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "thursday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "thursday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[4]?.OccMyPropertyChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 4) {
                                                                        item.OccMyPropertyChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccMyProperty
                                                                            ? parseFloat(item.OccMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[4].OccMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[4].OccMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[4]?.OccMyPropertyChange ? (
                                                    tableDataRef.current[4]?.OccMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[4]?.OccMyPropertyLy
                                                    ? tableDataRef.current[4]?.OccMyPropertyLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "friday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "friday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[5]?.OccMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 5) {
                                                                        item.OccMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccMyPropertyChange
                                                                            ? parseFloat(item.OccMyPropertyChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[5].OccMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[5].OccMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[5]?.OccMyProperty ? (
                                                    tableDataRef.current[5]?.OccMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "friday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "friday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[5]?.OccMyPropertyChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 5) {
                                                                        item.OccMyPropertyChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccMyProperty
                                                                            ? parseFloat(item.OccMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[5].OccMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[5].OccMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[5]?.OccMyPropertyChange ? (
                                                    tableDataRef.current[5]?.OccMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[5]?.OccMyPropertyLy
                                                    ? tableDataRef.current[5]?.OccMyPropertyLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "saturday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "saturday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[6]?.OccMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 6) {
                                                                        item.OccMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccMyPropertyChange
                                                                            ? parseFloat(item.OccMyPropertyChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[6].OccMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[6].OccMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[6]?.OccMyProperty ? (
                                                    tableDataRef.current[6]?.OccMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "saturday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "saturday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[6]?.OccMyPropertyChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 6) {
                                                                        item.OccMyPropertyChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccMyProperty
                                                                            ? parseFloat(item.OccMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[6].OccMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[6].OccMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[6]?.OccMyPropertyChange ? (
                                                    tableDataRef.current[6]?.OccMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[6]?.OccMyPropertyLy
                                                    ? tableDataRef.current[6]?.OccMyPropertyLy
                                                    : 0}
                                            </td>
                                            <td className="fontBold">
                                                {tableDataRef.current[7]?.OccMyProperty
                                                    ? tableDataRef.current[7]?.OccMyProperty
                                                    : 0}
                                            </td>
                                            <td className="fontBold">
                                                {tableDataRef.current[7]?.OccMyPropertyChange
                                                    ? tableDataRef.current[7]?.OccMyPropertyChange
                                                    : 0}
                                            </td>
                                        </tr>
                                        <tr className="shadowOnHover">
                                            <td className="border_right">Comp Set (%)</td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "sunday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "sunday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[0]?.OccCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 0) {
                                                                        item.OccCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccCompsetChange
                                                                            ? parseFloat(item.OccCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[0].OccCompset =
                                                                e.target.value;
                                                            tableDataRef.current[0].OccCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[0]?.OccCompset ? (
                                                    tableDataRef.current[0]?.OccCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "sunday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "sunday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "total-avg", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[0]?.OccCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 0) {
                                                                        item.OccCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccCompset
                                                                            ? parseFloat(item.OccCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[0].OccCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[0].OccCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[0]?.OccCompsetChange ? (
                                                    tableDataRef.current[0]?.OccCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[0]?.OccCompsetLy
                                                    ? tableDataRef.current[0]?.OccCompsetLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "monday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "monday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[1]?.OccCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 1) {
                                                                        item.OccCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccCompsetChange
                                                                            ? parseFloat(item.OccCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[1].OccCompset =
                                                                e.target.value;
                                                            tableDataRef.current[1].OccCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[1]?.OccCompset ? (
                                                    tableDataRef.current[1]?.OccCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "monday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "monday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[1]?.OccCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 1) {
                                                                        item.OccCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccCompset
                                                                            ? parseFloat(item.OccCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[1].OccCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[1].OccCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[1]?.OccCompsetChange ? (
                                                    tableDataRef.current[1]?.OccCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[1]?.OccCompsetLy
                                                    ? tableDataRef.current[1]?.OccCompsetLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "tuesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "tuesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[2]?.OccCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 2) {
                                                                        item.OccCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccCompsetChange
                                                                            ? parseFloat(item.OccCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[2].OccCompset =
                                                                e.target.value;
                                                            tableDataRef.current[2].OccCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[2]?.OccCompset ? (
                                                    tableDataRef.current[2]?.OccCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "tuesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "tuesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[2]?.OccCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 2) {
                                                                        item.OccCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccCompset
                                                                            ? parseFloat(item.OccCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[2].OccCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[2].OccCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[2]?.OccCompsetChange ? (
                                                    tableDataRef.current[2]?.OccCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[2]?.OccCompsetLy
                                                    ? tableDataRef.current[2]?.OccCompsetLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "wednesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "wednesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[3]?.OccCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 3) {
                                                                        item.OccCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccCompsetChange
                                                                            ? parseFloat(item.OccCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[3].OccCompset =
                                                                e.target.value;
                                                            tableDataRef.current[3].OccCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[3]?.OccCompset ? (
                                                    tableDataRef.current[3]?.OccCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "wednesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "wednesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[3]?.OccCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 3) {
                                                                        item.OccCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccCompset
                                                                            ? parseFloat(item.OccCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[3].OccCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[3].OccCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[3]?.OccCompsetChange ? (
                                                    tableDataRef.current[3]?.OccCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[3]?.OccCompsetLy
                                                    ? tableDataRef.current[3]?.OccCompsetLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "thursday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "thursday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[4]?.OccCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 4) {
                                                                        item.OccCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccCompsetChange
                                                                            ? parseFloat(item.OccCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[4].OccCompset =
                                                                e.target.value;
                                                            tableDataRef.current[4].OccCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[4]?.OccCompset ? (
                                                    tableDataRef.current[4]?.OccCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "thursday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "thursday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[4]?.OccCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 4) {
                                                                        item.OccCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccCompset
                                                                            ? parseFloat(item.OccCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[4].OccCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[4].OccCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[4]?.OccCompsetChange ? (
                                                    tableDataRef.current[4]?.OccCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[4]?.OccCompsetLy
                                                    ? tableDataRef.current[4]?.OccCompsetLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "friday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "friday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[5]?.OccCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 5) {
                                                                        item.OccCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccCompsetChange
                                                                            ? parseFloat(item.OccCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[5].OccCompset =
                                                                e.target.value;
                                                            tableDataRef.current[5].OccCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[5]?.OccCompset ? (
                                                    tableDataRef.current[5]?.OccCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "friday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "friday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[5]?.OccCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 5) {
                                                                        item.OccCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccCompset
                                                                            ? parseFloat(item.OccCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[5].OccCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[5].OccCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[5]?.OccCompsetChange ? (
                                                    tableDataRef.current[5]?.OccCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[5]?.OccCompsetLy
                                                    ? tableDataRef.current[5]?.OccCompsetLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "saturday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "saturday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[6]?.OccCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 6) {
                                                                        item.OccCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccCompsetChange
                                                                            ? parseFloat(item.OccCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[6].OccCompset =
                                                                e.target.value;
                                                            tableDataRef.current[6].OccCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[6]?.OccCompset ? (
                                                    tableDataRef.current[6]?.OccCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "saturday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "saturday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[6]?.OccCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 6) {
                                                                        item.OccCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccCompset
                                                                            ? parseFloat(item.OccCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[6].OccCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[6].OccCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[6]?.OccCompsetChange ? (
                                                    tableDataRef.current[6]?.OccCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[6]?.OccCompsetLy
                                                    ? tableDataRef.current[6]?.OccCompsetLy
                                                    : 0}
                                            </td>
                                            <td className="fontBold">
                                                {tableDataRef.current[7]?.OccCompset
                                                    ? tableDataRef.current[7]?.OccCompset
                                                    : 0}
                                            </td>
                                            <td className="fontBold">
                                                {tableDataRef.current[7]?.OccCompsetChange
                                                    ? tableDataRef.current[7]?.OccCompsetChange
                                                    : 0}
                                            </td>
                                        </tr>
                                        <tr className="shadowOnHover">
                                            <td className="border_right">Index (MPI)</td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "sunday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "sunday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[0]?.OccIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 0) {
                                                                        item.OccIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccIndexChange
                                                                            ? parseFloat(item.OccIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[0].OccIndex = e.target.value;
                                                            tableDataRef.current[0].OccIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[0]?.OccIndex ? (
                                                    tableDataRef.current[0]?.OccIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "sunday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "sunday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "total-avg", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[0]?.OccIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 0) {
                                                                        item.OccIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccIndex
                                                                            ? parseFloat(item.OccIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[0].OccIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[0].OccIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[0]?.OccIndexChange ? (
                                                    tableDataRef.current[0]?.OccIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[0]?.OccIndexLy
                                                    ? tableDataRef.current[0]?.OccIndexLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "monday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "monday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[1]?.OccIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 1) {
                                                                        item.OccIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccIndexChange
                                                                            ? parseFloat(item.OccIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[1].OccIndex = e.target.value;
                                                            tableDataRef.current[1].OccIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[1]?.OccIndex ? (
                                                    tableDataRef.current[1]?.OccIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "monday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "monday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[1]?.OccIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 1) {
                                                                        item.OccIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccIndex
                                                                            ? parseFloat(item.OccIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[1].OccIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[1].OccIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[1]?.OccIndexChange ? (
                                                    tableDataRef.current[1]?.OccIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[1]?.OccIndexLy
                                                    ? tableDataRef.current[1]?.OccIndexLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "tuesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "tuesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[2]?.OccIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 2) {
                                                                        item.OccIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccIndexChange
                                                                            ? parseFloat(item.OccIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[2].OccIndex = e.target.value;
                                                            tableDataRef.current[2].OccIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[2]?.OccIndex ? (
                                                    tableDataRef.current[2]?.OccIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "tuesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "tuesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[2]?.OccIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 2) {
                                                                        item.OccIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccIndex
                                                                            ? parseFloat(item.OccIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[2].OccIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[2].OccIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[2]?.OccIndexChange ? (
                                                    tableDataRef.current[2]?.OccIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[2]?.OccIndexLy
                                                    ? tableDataRef.current[2]?.OccIndexLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "wednesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "wednesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[3]?.OccIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 3) {
                                                                        item.OccIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccIndexChange
                                                                            ? parseFloat(item.OccIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[3].OccIndex = e.target.value;
                                                            tableDataRef.current[3].OccIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[3]?.OccIndex ? (
                                                    tableDataRef.current[3]?.OccIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "wednesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "wednesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[3]?.OccIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 3) {
                                                                        item.OccIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccIndex
                                                                            ? parseFloat(item.OccIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[3].OccIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[3].OccIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[3]?.OccIndexChange ? (
                                                    tableDataRef.current[3]?.OccIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[3]?.OccIndexLy
                                                    ? tableDataRef.current[3]?.OccIndexLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "thursday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "thursday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[4]?.OccIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 4) {
                                                                        item.OccIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccIndexChange
                                                                            ? parseFloat(item.OccIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[4].OccIndex = e.target.value;
                                                            tableDataRef.current[4].OccIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[4]?.OccIndex ? (
                                                    tableDataRef.current[4]?.OccIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "thursday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "thursday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[4]?.OccIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 4) {
                                                                        item.OccIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccIndex
                                                                            ? parseFloat(item.OccIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[4].OccIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[4].OccIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[4]?.OccIndexChange ? (
                                                    tableDataRef.current[4]?.OccIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[4]?.OccIndexLy
                                                    ? tableDataRef.current[4]?.OccIndexLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "friday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "friday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[5]?.OccIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 5) {
                                                                        item.OccIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccIndexChange
                                                                            ? parseFloat(item.OccIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[5].OccIndex = e.target.value;
                                                            tableDataRef.current[5].OccIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[5]?.OccIndex ? (
                                                    tableDataRef.current[5]?.OccIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "friday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "friday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[5]?.OccIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 5) {
                                                                        item.OccIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccIndex
                                                                            ? parseFloat(item.OccIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[5].OccIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[5].OccIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[5]?.OccIndexChange ? (
                                                    tableDataRef.current[5]?.OccIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[5]?.OccIndexLy
                                                    ? tableDataRef.current[5]?.OccIndexLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "saturday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "saturday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[6]?.OccIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 6) {
                                                                        item.OccIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.OccIndexChange
                                                                            ? parseFloat(item.OccIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.OccIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[6].OccIndex = e.target.value;
                                                            tableDataRef.current[6].OccIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[6]?.OccIndex ? (
                                                    tableDataRef.current[6]?.OccIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "occ",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "saturday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "occ" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "saturday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[6]?.OccIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 6) {
                                                                        item.OccIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.OccIndex
                                                                            ? parseFloat(item.OccIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.OccIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[6].OccIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[6].OccIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[6]?.OccIndexChange ? (
                                                    tableDataRef.current[6]?.OccIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[6]?.OccIndexLy
                                                    ? tableDataRef.current[6]?.OccIndexLy
                                                    : 0}
                                            </td>
                                            <td className="fontBold">
                                                {tableDataRef.current[7]?.OccIndex
                                                    ? tableDataRef.current[7]?.OccIndex
                                                    : 0}
                                            </td>
                                            <td className="fontBold">
                                                {tableDataRef.current[7]?.OccIndexChange
                                                    ? tableDataRef.current[7]?.OccIndexChange
                                                    : 0}
                                            </td>
                                        </tr>

                                        {/* ADR */}
                                        <tr className="shadowOnHover">
                                            <td rowSpan={3} className="th-with-rowspan border_right">
                                                ADR
                                            </td>
                                            <td className="border_right">My Property</td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "adr",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "sunday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "adr" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "sunday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "total-avg", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[0]?.AdrMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 0) {
                                                                        item.AdrMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrMyPropertyChange
                                                                            ? parseFloat(item.AdrMyPropertyChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[0].AdrMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[0].AdrMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[0]?.AdrMyProperty ? (
                                                    tableDataRef.current[0]?.AdrMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "adr",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "sunday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "adr" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "sunday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "total-chg", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[0]?.AdrMyPropertyChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 0) {
                                                                        item.AdrMyPropertyChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrMyProperty
                                                                            ? parseFloat(item.AdrMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[0].AdrMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[0].AdrMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[0]?.AdrMyPropertyChange ? (
                                                    tableDataRef.current[0]?.AdrMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[0]?.AdrMyPropertyLy
                                                    ? tableDataRef.current[0]?.AdrMyPropertyLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "adr",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "monday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "adr" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "monday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[1]?.AdrMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 1) {
                                                                        item.AdrMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrMyPropertyChange
                                                                            ? parseFloat(item.AdrMyPropertyChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[1].AdrMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[1].AdrMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[1]?.AdrMyProperty ? (
                                                    tableDataRef.current[1]?.AdrMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "adr",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "monday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "adr" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "monday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[1]?.AdrMyPropertyChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 1) {
                                                                        item.AdrMyPropertyChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrMyProperty
                                                                            ? parseFloat(item.AdrMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[1].AdrMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[1].AdrMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[1]?.AdrMyPropertyChange ? (
                                                    tableDataRef.current[1]?.AdrMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[1]?.AdrMyPropertyLy
                                                    ? tableDataRef.current[1]?.AdrMyPropertyLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "adr",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "tuseday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "adr" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "tuseday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[2]?.AdrMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 2) {
                                                                        item.AdrMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrMyPropertyChange
                                                                            ? parseFloat(item.AdrMyPropertyChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[2].AdrMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[2].AdrMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[2]?.AdrMyProperty ? (
                                                    tableDataRef.current[2]?.AdrMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "tuesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "tuesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[2]?.AdrMyPropertyChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 2) {
                                                                        item.AdrMyPropertyChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrMyProperty
                                                                            ? parseFloat(item.AdrMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[2].AdrMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[2].AdrMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[2]?.AdrMyPropertyChange ? (
                                                    tableDataRef.current[2]?.AdrMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[2]?.AdrMyPropertyLy
                                                    ? tableDataRef.current[2]?.AdrMyPropertyLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "wednesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "wednesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[3]?.AdrMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 3) {
                                                                        item.AdrMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrMyPropertyChange
                                                                            ? parseFloat(item.AdrMyPropertyChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[3].AdrMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[3].AdrMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[3]?.AdrMyProperty ? (
                                                    tableDataRef.current[3]?.AdrMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "wednesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "wednesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[3]?.AdrMyPropertyChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 3) {
                                                                        item.AdrMyPropertyChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrMyProperty
                                                                            ? parseFloat(item.AdrMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[3].AdrMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[3].AdrMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[3]?.AdrMyPropertyChange ? (
                                                    tableDataRef.current[3]?.AdrMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[3]?.AdrMyPropertyLy
                                                    ? tableDataRef.current[3]?.AdrMyPropertyLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "thursday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "thursday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[4]?.AdrMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 4) {
                                                                        item.AdrMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrMyPropertyChange
                                                                            ? parseFloat(item.AdrMyPropertyChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[4].AdrMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[4].AdrMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[4]?.AdrMyProperty ? (
                                                    tableDataRef.current[4]?.AdrMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "thursday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "thursday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[4]?.AdrMyPropertyChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 4) {
                                                                        item.AdrMyPropertyChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrMyProperty
                                                                            ? parseFloat(item.AdrMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[4].AdrMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[4].AdrMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[4]?.AdrMyPropertyChange ? (
                                                    tableDataRef.current[4]?.AdrMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[4]?.AdrMyPropertyLy
                                                    ? tableDataRef.current[4]?.AdrMyPropertyLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "friday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "friday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[5]?.AdrMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 5) {
                                                                        item.AdrMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrMyPropertyChange
                                                                            ? parseFloat(item.AdrMyPropertyChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[5].AdrMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[5].AdrMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[5]?.AdrMyProperty ? (
                                                    tableDataRef.current[5]?.AdrMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "friday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "friday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[5]?.AdrMyPropertyChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 5) {
                                                                        item.AdrMyPropertyChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrMyProperty
                                                                            ? parseFloat(item.AdrMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[5].AdrMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[5].AdrMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[5]?.AdrMyPropertyChange ? (
                                                    tableDataRef.current[5]?.AdrMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[5]?.AdrMyPropertyLy
                                                    ? tableDataRef.current[5]?.AdrMyPropertyLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "saturday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "saturday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[6]?.AdrMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 6) {
                                                                        item.AdrMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrMyPropertyChange
                                                                            ? parseFloat(item.AdrMyPropertyChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[6].AdrMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[6].AdrMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[6]?.AdrMyProperty ? (
                                                    tableDataRef.current[6]?.AdrMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "saturday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "saturday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[6]?.AdrMyPropertyChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 6) {
                                                                        item.AdrMyPropertyChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrMyProperty
                                                                            ? parseFloat(item.AdrMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[6].AdrMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[6].AdrMyPropertyLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[6]?.AdrMyPropertyChange ? (
                                                    tableDataRef.current[6]?.AdrMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[6]?.AdrMyPropertyLy
                                                    ? tableDataRef.current[6]?.AdrMyPropertyLy
                                                    : 0}
                                            </td>
                                            <td className="fontBold">
                                                {tableDataRef.current[7]?.AdrMyProperty
                                                    ? tableDataRef.current[7]?.AdrMyProperty
                                                    : 0}
                                            </td>
                                            <td className="fontBold">
                                                {tableDataRef.current[7]?.AdrMyPropertyChange
                                                    ? tableDataRef.current[7]?.AdrMyPropertyChange
                                                    : 0}
                                            </td>
                                        </tr>
                                        <tr className="shadowOnHover">
                                            <td className="border_right">Comp Set</td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "sunday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "sunday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[0]?.AdrCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 0) {
                                                                        item.AdrCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrCompsetChange
                                                                            ? parseFloat(item.AdrCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[0].AdrCompset =
                                                                e.target.value;
                                                            tableDataRef.current[0].AdrCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[0]?.AdrCompset ? (
                                                    tableDataRef.current[0]?.AdrCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "sunday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "sunday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "total-avg", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[0]?.AdrCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 0) {
                                                                        item.AdrCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrCompset
                                                                            ? parseFloat(item.AdrCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[0].AdrCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[0].AdrCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[0]?.AdrCompsetChange ? (
                                                    tableDataRef.current[0]?.AdrCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[0]?.AdrCompsetLy
                                                    ? tableDataRef.current[0]?.AdrCompsetLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "monday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "monday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[1]?.AdrCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 1) {
                                                                        item.AdrCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrCompsetChange
                                                                            ? parseFloat(item.AdrCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[1].AdrCompset =
                                                                e.target.value;
                                                            tableDataRef.current[1].AdrCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[1]?.AdrCompset ? (
                                                    tableDataRef.current[1]?.AdrCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "monday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "monday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[1]?.AdrCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 1) {
                                                                        item.AdrCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrCompset
                                                                            ? parseFloat(item.AdrCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[1].AdrCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[1].AdrCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[1]?.AdrCompsetChange ? (
                                                    tableDataRef.current[1]?.AdrCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[1]?.AdrCompsetLy
                                                    ? tableDataRef.current[1]?.AdrCompsetLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "tuesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "tuesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[2]?.AdrCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 2) {
                                                                        item.AdrCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrCompsetChange
                                                                            ? parseFloat(item.AdrCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[2].AdrCompset =
                                                                e.target.value;
                                                            tableDataRef.current[2].AdrCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[2]?.AdrCompset ? (
                                                    tableDataRef.current[2]?.AdrCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "tuesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "tuesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[2]?.AdrCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 2) {
                                                                        item.AdrCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrCompset
                                                                            ? parseFloat(item.AdrCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[2].AdrCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[2].AdrCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[2]?.AdrCompsetChange ? (
                                                    tableDataRef.current[2]?.AdrCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[2]?.AdrCompsetLy
                                                    ? tableDataRef.current[2]?.AdrCompsetLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "wednesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "wednesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[3]?.AdrCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 3) {
                                                                        item.AdrCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrCompsetChange
                                                                            ? parseFloat(item.AdrCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[3].AdrCompset =
                                                                e.target.value;
                                                            tableDataRef.current[3].AdrCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[3]?.AdrCompset ? (
                                                    tableDataRef.current[3]?.AdrCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "wednesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "wednesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[3]?.AdrCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 3) {
                                                                        item.AdrCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrCompset
                                                                            ? parseFloat(item.AdrCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[3].AdrCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[3].AdrCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[3]?.AdrCompsetChange ? (
                                                    tableDataRef.current[3]?.AdrCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[3]?.AdrCompsetLy
                                                    ? tableDataRef.current[3]?.AdrCompsetLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "thursday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "thursday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[4]?.AdrCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 4) {
                                                                        item.AdrCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrCompsetChange
                                                                            ? parseFloat(item.AdrCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[4].AdrCompset =
                                                                e.target.value;
                                                            tableDataRef.current[4].AdrCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[4]?.AdrCompset ? (
                                                    tableDataRef.current[4]?.AdrCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "thursday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "thursday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[4]?.AdrCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 4) {
                                                                        item.AdrCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrCompset
                                                                            ? parseFloat(item.AdrCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[4].AdrCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[4].AdrCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[4]?.AdrCompsetChange ? (
                                                    tableDataRef.current[4]?.AdrCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[4]?.AdrCompsetLy
                                                    ? tableDataRef.current[4]?.AdrCompsetLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "friday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "friday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[5]?.AdrCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 5) {
                                                                        item.AdrCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrCompsetChange
                                                                            ? parseFloat(item.AdrCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[5].AdrCompset =
                                                                e.target.value;
                                                            tableDataRef.current[5].AdrCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[5]?.AdrCompset ? (
                                                    tableDataRef.current[5]?.AdrCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "friday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "friday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[5]?.AdrCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 5) {
                                                                        item.AdrCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrCompset
                                                                            ? parseFloat(item.AdrCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[5].AdrCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[5].AdrCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[5]?.AdrCompsetChange ? (
                                                    tableDataRef.current[5]?.AdrCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[5]?.AdrCompsetLy
                                                    ? tableDataRef.current[5]?.AdrCompsetLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "saturday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "saturday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[6]?.AdrCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 6) {
                                                                        item.AdrCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrCompsetChange
                                                                            ? parseFloat(item.AdrCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[6].AdrCompset =
                                                                e.target.value;
                                                            tableDataRef.current[6].AdrCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[6]?.AdrCompset ? (
                                                    tableDataRef.current[6]?.AdrCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "saturday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "saturday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[6]?.AdrCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 6) {
                                                                        item.AdrCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrCompset
                                                                            ? parseFloat(item.AdrCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[6].AdrCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[6].AdrCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[6]?.AdrCompsetChange ? (
                                                    tableDataRef.current[6]?.AdrCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[6]?.AdrCompsetLy
                                                    ? tableDataRef.current[6]?.AdrCompsetLy
                                                    : 0}
                                            </td>
                                            <td className="fontBold">
                                                {tableDataRef.current[7]?.AdrCompset
                                                    ? tableDataRef.current[7]?.AdrCompset
                                                    : 0}
                                            </td>
                                            <td className="fontBold">
                                                {tableDataRef.current[7]?.AdrCompsetChange
                                                    ? tableDataRef.current[7]?.AdrCompsetChange
                                                    : 0}
                                            </td>
                                        </tr>
                                        <tr className="shadowOnHover">
                                            <td className="border_right">Index (ARI)</td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "sunday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "sunday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[0]?.AdrIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 0) {
                                                                        item.AdrIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrIndexChange
                                                                            ? parseFloat(item.AdrIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[0].AdrIndex = e.target.value;
                                                            tableDataRef.current[0].AdrIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[0]?.AdrIndex ? (
                                                    tableDataRef.current[0]?.AdrIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "sunday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "sunday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "total-avg", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[0]?.AdrIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 0) {
                                                                        item.AdrIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrIndex
                                                                            ? parseFloat(item.AdrIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[0].AdrIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[0].AdrIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[0]?.AdrIndexChange ? (
                                                    tableDataRef.current[0]?.AdrIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[0]?.AdrIndexLy
                                                    ? tableDataRef.current[0]?.AdrIndexLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "monday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "monday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[1]?.AdrIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 1) {
                                                                        item.AdrIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrIndexChange
                                                                            ? parseFloat(item.AdrIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[1].AdrIndex = e.target.value;
                                                            tableDataRef.current[1].AdrIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[1]?.AdrIndex ? (
                                                    tableDataRef.current[1]?.AdrIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "monday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "monday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[1]?.AdrIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 1) {
                                                                        item.AdrIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrIndex
                                                                            ? parseFloat(item.AdrIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[1].AdrIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[1].AdrIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[1]?.AdrIndexChange ? (
                                                    tableDataRef.current[1]?.AdrIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[1]?.AdrIndexLy
                                                    ? tableDataRef.current[1]?.AdrIndexLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "tuesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "tuesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[2]?.AdrIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 2) {
                                                                        item.AdrIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrIndexChange
                                                                            ? parseFloat(item.AdrIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[2].AdrIndex = e.target.value;
                                                            tableDataRef.current[2].AdrIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[2]?.AdrIndex ? (
                                                    tableDataRef.current[2]?.AdrIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "tuesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "tuesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[2]?.AdrIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 2) {
                                                                        item.AdrIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrIndex
                                                                            ? parseFloat(item.AdrIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[2].AdrIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[2].AdrIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[2]?.AdrIndexChange ? (
                                                    tableDataRef.current[2]?.AdrIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[2]?.AdrIndexLy
                                                    ? tableDataRef.current[2]?.AdrIndexLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "wednesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "wednesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[3]?.AdrIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 3) {
                                                                        item.AdrIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrIndexChange
                                                                            ? parseFloat(item.AdrIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[3].AdrIndex = e.target.value;
                                                            tableDataRef.current[3].AdrIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[3]?.AdrIndex ? (
                                                    tableDataRef.current[3]?.AdrIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "wednesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "wednesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[3]?.AdrIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 3) {
                                                                        item.AdrIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrIndex
                                                                            ? parseFloat(item.AdrIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[3].AdrIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[3].AdrIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[3]?.AdrIndexChange ? (
                                                    tableDataRef.current[3]?.AdrIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[3]?.AdrIndexLy
                                                    ? tableDataRef.current[3]?.AdrIndexLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "thursday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "thursday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[4]?.AdrIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 4) {
                                                                        item.AdrIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrIndexChange
                                                                            ? parseFloat(item.AdrIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[4].AdrIndex = e.target.value;
                                                            tableDataRef.current[4].AdrIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[4]?.AdrIndex ? (
                                                    tableDataRef.current[4]?.AdrIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "thursday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "thursday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[4]?.AdrIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 4) {
                                                                        item.AdrIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrIndex
                                                                            ? parseFloat(item.AdrIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[4].AdrIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[4].AdrIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[4]?.AdrIndexChange ? (
                                                    tableDataRef.current[4]?.AdrIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[4]?.AdrIndexLy
                                                    ? tableDataRef.current[4]?.AdrIndexLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "friday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "friday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[5]?.AdrIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 5) {
                                                                        item.AdrIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrIndexChange
                                                                            ? parseFloat(item.AdrIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[5].AdrIndex = e.target.value;
                                                            tableDataRef.current[5].AdrIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[5]?.AdrIndex ? (
                                                    tableDataRef.current[5]?.AdrIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "friday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "friday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[5]?.AdrIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 5) {
                                                                        item.AdrIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrIndex
                                                                            ? parseFloat(item.AdrIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[5].AdrIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[5].AdrIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[5]?.AdrIndexChange ? (
                                                    tableDataRef.current[5]?.AdrIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[5]?.AdrIndexLy
                                                    ? tableDataRef.current[5]?.AdrIndexLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "saturday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "saturday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[6]?.AdrIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 6) {
                                                                        item.AdrIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.AdrIndexChange
                                                                            ? parseFloat(item.AdrIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[6].AdrIndex = e.target.value;
                                                            tableDataRef.current[6].AdrIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[6]?.AdrIndex ? (
                                                    tableDataRef.current[6]?.AdrIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Adr",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "saturday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Adr" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "saturday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[6]?.AdrIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 6) {
                                                                        item.AdrIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.AdrIndex
                                                                            ? parseFloat(item.AdrIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.AdrIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[6].AdrIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[6].AdrIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[6]?.AdrIndexChange ? (
                                                    tableDataRef.current[6]?.AdrIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[6]?.AdrIndexLy
                                                    ? tableDataRef.current[6]?.AdrIndexLy
                                                    : 0}
                                            </td>
                                            <td className="fontBold">
                                                {tableDataRef.current[7]?.AdrIndex
                                                    ? tableDataRef.current[7]?.AdrIndex
                                                    : 0}
                                            </td>
                                            <td className="fontBold">
                                                {tableDataRef.current[7]?.AdrIndexChange
                                                    ? tableDataRef.current[7]?.AdrIndexChange
                                                    : 0}
                                            </td>
                                        </tr>

                                        {/* REVPAR */}
                                        <tr className="shadowOnHover">
                                            <td rowSpan={3} className="th-with-rowspan border_right">
                                                RevPAR
                                            </td>
                                            <td className="border_right">My Property</td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "sunday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "sunday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "total-avg", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[0]?.RevparMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 0) {
                                                                        item.RevparMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue =
                                                                            item?.RevparMyPropertyChange
                                                                                ? parseFloat(
                                                                                    item.RevparMyPropertyChange
                                                                                )
                                                                                : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[0].RevparMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[0].RevparMyPropertyLy =
                                                                lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[0]?.RevparMyProperty ? (
                                                    tableDataRef.current[0]?.RevparMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "sunday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "sunday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "total-chg", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={
                                                            tableDataRef.current[0]?.RevparMyPropertyChange
                                                        }
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 0) {
                                                                        item.RevparMyPropertyChange =
                                                                            e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparMyProperty
                                                                            ? parseFloat(item.RevparMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[0].RevparMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[0].RevparMyPropertyLy =
                                                                lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[0]?.RevparMyPropertyChange ? (
                                                    tableDataRef.current[0]?.RevparMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[0]?.RevparMyPropertyLy
                                                    ? tableDataRef.current[0]?.RevparMyPropertyLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "monday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "monday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[1]?.RevparMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 1) {
                                                                        item.RevparMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue =
                                                                            item?.RevparMyPropertyChange
                                                                                ? parseFloat(
                                                                                    item.RevparMyPropertyChange
                                                                                )
                                                                                : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[1].RevparMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[1].RevparMyPropertyLy =
                                                                lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[1]?.RevparMyProperty ? (
                                                    tableDataRef.current[1]?.RevparMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "monday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "monday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={
                                                            tableDataRef.current[1]?.RevparMyPropertyChange
                                                        }
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 1) {
                                                                        item.RevparMyPropertyChange =
                                                                            e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparMyProperty
                                                                            ? parseFloat(item.RevparMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[1].RevparMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[1].RevparMyPropertyLy =
                                                                lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[1]?.RevparMyPropertyChange ? (
                                                    tableDataRef.current[1]?.RevparMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[1]?.RevparMyPropertyLy
                                                    ? tableDataRef.current[1]?.RevparMyPropertyLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "tuseday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "tuseday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[2]?.RevparMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 2) {
                                                                        item.RevparMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue =
                                                                            item?.RevparMyPropertyChange
                                                                                ? parseFloat(
                                                                                    item.RevparMyPropertyChange
                                                                                )
                                                                                : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[2].RevparMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[2].RevparMyPropertyLy =
                                                                lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[2]?.RevparMyProperty ? (
                                                    tableDataRef.current[2]?.RevparMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "tuesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "tuesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={
                                                            tableDataRef.current[2]?.RevparMyPropertyChange
                                                        }
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 2) {
                                                                        item.RevparMyPropertyChange =
                                                                            e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparMyProperty
                                                                            ? parseFloat(item.RevparMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[2].RevparMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[2].RevparMyPropertyLy =
                                                                lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[2]?.RevparMyPropertyChange ? (
                                                    tableDataRef.current[2]?.RevparMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[2]?.RevparMyPropertyLy
                                                    ? tableDataRef.current[2]?.RevparMyPropertyLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "wednesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "wednesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[3]?.RevparMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 3) {
                                                                        item.RevparMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue =
                                                                            item?.RevparMyPropertyChange
                                                                                ? parseFloat(
                                                                                    item.RevparMyPropertyChange
                                                                                )
                                                                                : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[3].RevparMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[3].RevparMyPropertyLy =
                                                                lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[3]?.RevparMyProperty ? (
                                                    tableDataRef.current[3]?.RevparMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "wednesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "wednesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={
                                                            tableDataRef.current[3]?.RevparMyPropertyChange
                                                        }
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 3) {
                                                                        item.RevparMyPropertyChange =
                                                                            e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparMyProperty
                                                                            ? parseFloat(item.RevparMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[3].RevparMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[3].RevparMyPropertyLy =
                                                                lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[3]?.RevparMyPropertyChange ? (
                                                    tableDataRef.current[3]?.RevparMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[3]?.RevparMyPropertyLy
                                                    ? tableDataRef.current[3]?.RevparMyPropertyLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "thursday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "thursday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[4]?.RevparMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 4) {
                                                                        item.RevparMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue =
                                                                            item?.RevparMyPropertyChange
                                                                                ? parseFloat(
                                                                                    item.RevparMyPropertyChange
                                                                                )
                                                                                : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[4].RevparMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[4].RevparMyPropertyLy =
                                                                lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[4]?.RevparMyProperty ? (
                                                    tableDataRef.current[4]?.RevparMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "thursday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "thursday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={
                                                            tableDataRef.current[4]?.RevparMyPropertyChange
                                                        }
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 4) {
                                                                        item.RevparMyPropertyChange =
                                                                            e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparMyProperty
                                                                            ? parseFloat(item.RevparMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[4].RevparMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[4].RevparMyPropertyLy =
                                                                lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[4]?.RevparMyPropertyChange ? (
                                                    tableDataRef.current[4]?.RevparMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[4]?.RevparMyPropertyLy
                                                    ? tableDataRef.current[4]?.RevparMyPropertyLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "friday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "friday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[5]?.RevparMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 5) {
                                                                        item.RevparMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue =
                                                                            item?.RevparMyPropertyChange
                                                                                ? parseFloat(
                                                                                    item.RevparMyPropertyChange
                                                                                )
                                                                                : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[5].RevparMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[5].RevparMyPropertyLy =
                                                                lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[5]?.RevparMyProperty ? (
                                                    tableDataRef.current[5]?.RevparMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "friday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "friday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={
                                                            tableDataRef.current[5]?.RevparMyPropertyChange
                                                        }
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 5) {
                                                                        item.RevparMyPropertyChange =
                                                                            e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparMyProperty
                                                                            ? parseFloat(item.RevparMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[5].RevparMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[5].RevparMyPropertyLy =
                                                                lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[5]?.RevparMyPropertyChange ? (
                                                    tableDataRef.current[5]?.RevparMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[5]?.RevparMyPropertyLy
                                                    ? tableDataRef.current[5]?.RevparMyPropertyLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "myProperty",
                                            //     field: "curr",
                                            //     day: "saturday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "saturday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[6]?.RevparMyProperty}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 6) {
                                                                        item.RevparMyProperty = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue =
                                                                            item?.RevparMyPropertyChange
                                                                                ? parseFloat(
                                                                                    item.RevparMyPropertyChange
                                                                                )
                                                                                : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[6].RevparMyProperty =
                                                                e.target.value;
                                                            tableDataRef.current[6].RevparMyPropertyLy =
                                                                lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[6]?.RevparMyProperty ? (
                                                    tableDataRef.current[6]?.RevparMyProperty
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "myProperty",
                                            //     field: "change",
                                            //     day: "saturday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "myProperty" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "saturday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={
                                                            tableDataRef.current[6]?.RevparMyPropertyChange
                                                        }
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 6) {
                                                                        item.RevparMyPropertyChange =
                                                                            e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparMyProperty
                                                                            ? parseFloat(item.RevparMyProperty)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparMyPropertyLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[6].RevparMyPropertyChange =
                                                                e.target.value;
                                                            tableDataRef.current[6].RevparMyPropertyLy =
                                                                lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[6]?.RevparMyPropertyChange ? (
                                                    tableDataRef.current[6]?.RevparMyPropertyChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[6]?.RevparMyPropertyLy
                                                    ? tableDataRef.current[6]?.RevparMyPropertyLy
                                                    : 0}
                                            </td>
                                            <td className="fontBold">
                                                {tableDataRef.current[7]?.RevparMyProperty
                                                    ? tableDataRef.current[7]?.RevparMyProperty
                                                    : 0}
                                            </td>
                                            <td className="fontBold">
                                                {tableDataRef.current[7]?.RevparMyPropertyChange
                                                    ? tableDataRef.current[7]?.RevparMyPropertyChange
                                                    : 0}
                                            </td>
                                        </tr>
                                        <tr className="shadowOnHover">
                                            <td className="border_right">Comp Set</td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "sunday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "sunday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[0]?.RevparCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 0) {
                                                                        item.RevparCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.RevparCompsetChange
                                                                            ? parseFloat(item.RevparCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[0].RevparCompset =
                                                                e.target.value;
                                                            tableDataRef.current[0].RevparCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[0]?.RevparCompset ? (
                                                    tableDataRef.current[0]?.RevparCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "sunday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "sunday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "total-avg", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[0]?.RevparCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 0) {
                                                                        item.RevparCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparCompset
                                                                            ? parseFloat(item.RevparCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[0].RevparCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[0].RevparCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[0]?.RevparCompsetChange ? (
                                                    tableDataRef.current[0]?.RevparCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[0]?.RevparCompsetLy
                                                    ? tableDataRef.current[0]?.RevparCompsetLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "monday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "monday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[1]?.RevparCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 1) {
                                                                        item.RevparCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.RevparCompsetChange
                                                                            ? parseFloat(item.RevparCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[1].RevparCompset =
                                                                e.target.value;
                                                            tableDataRef.current[1].RevparCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[1]?.RevparCompset ? (
                                                    tableDataRef.current[1]?.RevparCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "monday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "monday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[1]?.RevparCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 1) {
                                                                        item.RevparCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparCompset
                                                                            ? parseFloat(item.RevparCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[1].RevparCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[1].RevparCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[1]?.RevparCompsetChange ? (
                                                    tableDataRef.current[1]?.RevparCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[1]?.RevparCompsetLy
                                                    ? tableDataRef.current[1]?.RevparCompsetLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "tuesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "tuesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[2]?.RevparCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 2) {
                                                                        item.RevparCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.RevparCompsetChange
                                                                            ? parseFloat(item.RevparCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[2].RevparCompset =
                                                                e.target.value;
                                                            tableDataRef.current[2].RevparCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[2]?.RevparCompset ? (
                                                    tableDataRef.current[2]?.RevparCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "tuesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "tuesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[2]?.RevparCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 2) {
                                                                        item.RevparCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparCompset
                                                                            ? parseFloat(item.RevparCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[2].RevparCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[2].RevparCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[2]?.RevparCompsetChange ? (
                                                    tableDataRef.current[2]?.RevparCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[2]?.RevparCompsetLy
                                                    ? tableDataRef.current[2]?.RevparCompsetLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "wednesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "wednesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[3]?.RevparCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 3) {
                                                                        item.RevparCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.RevparCompsetChange
                                                                            ? parseFloat(item.RevparCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[3].RevparCompset =
                                                                e.target.value;
                                                            tableDataRef.current[3].RevparCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[3]?.RevparCompset ? (
                                                    tableDataRef.current[3]?.RevparCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "wednesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "wednesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[3]?.RevparCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 3) {
                                                                        item.RevparCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparCompset
                                                                            ? parseFloat(item.RevparCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[3].RevparCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[3].RevparCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[3]?.RevparCompsetChange ? (
                                                    tableDataRef.current[3]?.RevparCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[3]?.RevparCompsetLy
                                                    ? tableDataRef.current[3]?.RevparCompsetLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "thursday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "thursday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[4]?.RevparCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 4) {
                                                                        item.RevparCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.RevparCompsetChange
                                                                            ? parseFloat(item.RevparCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[4].RevparCompset =
                                                                e.target.value;
                                                            tableDataRef.current[4].RevparCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[4]?.RevparCompset ? (
                                                    tableDataRef.current[4]?.RevparCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "thursday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "thursday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[4]?.RevparCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 4) {
                                                                        item.RevparCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparCompset
                                                                            ? parseFloat(item.RevparCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[4].RevparCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[4].RevparCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[4]?.RevparCompsetChange ? (
                                                    tableDataRef.current[4]?.RevparCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[4]?.RevparCompsetLy
                                                    ? tableDataRef.current[4]?.RevparCompsetLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "friday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "friday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[5]?.RevparCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 5) {
                                                                        item.RevparCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.RevparCompsetChange
                                                                            ? parseFloat(item.RevparCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[5].RevparCompset =
                                                                e.target.value;
                                                            tableDataRef.current[5].RevparCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[5]?.RevparCompset ? (
                                                    tableDataRef.current[5]?.RevparCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "friday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "friday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[5]?.RevparCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 5) {
                                                                        item.RevparCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparCompset
                                                                            ? parseFloat(item.RevparCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[5].RevparCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[5].RevparCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[5]?.RevparCompsetChange ? (
                                                    tableDataRef.current[5]?.RevparCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[5]?.RevparCompsetLy
                                                    ? tableDataRef.current[5]?.RevparCompsetLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "compSet",
                                            //     field: "curr",
                                            //     day: "saturday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "saturday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[6]?.RevparCompset}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 6) {
                                                                        item.RevparCompset = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.RevparCompsetChange
                                                                            ? parseFloat(item.RevparCompsetChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[6].RevparCompset =
                                                                e.target.value;
                                                            tableDataRef.current[6].RevparCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[6]?.RevparCompset ? (
                                                    tableDataRef.current[6]?.RevparCompset
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "compSet",
                                            //     field: "change",
                                            //     day: "saturday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "compSet" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "saturday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[6]?.RevparCompsetChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 6) {
                                                                        item.RevparCompsetChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparCompset
                                                                            ? parseFloat(item.RevparCompset)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparCompsetLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[6].RevparCompsetChange =
                                                                e.target.value;
                                                            tableDataRef.current[6].RevparCompsetLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[6]?.RevparCompsetChange ? (
                                                    tableDataRef.current[6]?.RevparCompsetChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[6]?.RevparCompsetLy
                                                    ? tableDataRef.current[6]?.RevparCompsetLy
                                                    : 0}
                                            </td>
                                            <td className="fontBold">
                                                {tableDataRef.current[7]?.RevparCompset
                                                    ? tableDataRef.current[7]?.RevparCompset
                                                    : 0}
                                            </td>
                                            <td className="fontBold">
                                                {tableDataRef.current[7]?.RevparCompsetChange
                                                    ? tableDataRef.current[7]?.RevparCompsetChange
                                                    : 0}
                                            </td>
                                        </tr>
                                        <tr className="shadowOnHover">
                                            <td className="border_right">Index (RGI)</td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "sunday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "sunday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[0]?.RevparIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 0) {
                                                                        item.RevparIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.RevparIndexChange
                                                                            ? parseFloat(item.RevparIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[0].RevparIndex =
                                                                e.target.value;
                                                            tableDataRef.current[0].RevparIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[0]?.RevparIndex ? (
                                                    tableDataRef.current[0]?.RevparIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "sunday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "sunday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "total-avg", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[0]?.RevparIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 0) {
                                                                        item.RevparIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparIndex
                                                                            ? parseFloat(item.RevparIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[0].RevparIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[0].RevparIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[0]?.RevparIndexChange ? (
                                                    tableDataRef.current[0]?.RevparIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[0]?.RevparIndexLy
                                                    ? tableDataRef.current[0]?.RevparIndexLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "monday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "monday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[1]?.RevparIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 1) {
                                                                        item.RevparIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.RevparIndexChange
                                                                            ? parseFloat(item.RevparIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[1].RevparIndex =
                                                                e.target.value;
                                                            tableDataRef.current[1].RevparIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[1]?.RevparIndex ? (
                                                    tableDataRef.current[1]?.RevparIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "monday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "monday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[1]?.RevparIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 1) {
                                                                        item.RevparIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparIndex
                                                                            ? parseFloat(item.RevparIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[1].RevparIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[1].RevparIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[1]?.RevparIndexChange ? (
                                                    tableDataRef.current[1]?.RevparIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[1]?.RevparIndexLy
                                                    ? tableDataRef.current[1]?.RevparIndexLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "tuesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "tuesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[2]?.RevparIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 2) {
                                                                        item.RevparIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.RevparIndexChange
                                                                            ? parseFloat(item.RevparIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[2].RevparIndex =
                                                                e.target.value;
                                                            tableDataRef.current[2].RevparIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[2]?.RevparIndex ? (
                                                    tableDataRef.current[2]?.RevparIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "tuesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "tuesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[2]?.RevparIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 2) {
                                                                        item.RevparIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparIndex
                                                                            ? parseFloat(item.RevparIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[2].RevparIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[2].RevparIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[2]?.RevparIndexChange ? (
                                                    tableDataRef.current[2]?.RevparIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[2]?.RevparIndexLy
                                                    ? tableDataRef.current[2]?.RevparIndexLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "wednesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "wednesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[3]?.RevparIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 3) {
                                                                        item.RevparIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.RevparIndexChange
                                                                            ? parseFloat(item.RevparIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[3].RevparIndex =
                                                                e.target.value;
                                                            tableDataRef.current[3].RevparIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[3]?.RevparIndex ? (
                                                    tableDataRef.current[3]?.RevparIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "wednesday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "wednesday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[3]?.RevparIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 3) {
                                                                        item.RevparIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparIndex
                                                                            ? parseFloat(item.RevparIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[3].RevparIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[3].RevparIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[3]?.RevparIndexChange ? (
                                                    tableDataRef.current[3]?.RevparIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[3]?.RevparIndexLy
                                                    ? tableDataRef.current[3]?.RevparIndexLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "thursday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "thursday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[4]?.RevparIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 4) {
                                                                        item.RevparIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.RevparIndexChange
                                                                            ? parseFloat(item.RevparIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[4].RevparIndex =
                                                                e.target.value;
                                                            tableDataRef.current[4].RevparIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[4]?.RevparIndex ? (
                                                    tableDataRef.current[4]?.RevparIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "thursday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "thursday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[4]?.RevparIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 4) {
                                                                        item.RevparIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparIndex
                                                                            ? parseFloat(item.RevparIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[4].RevparIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[4].RevparIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[4]?.RevparIndexChange ? (
                                                    tableDataRef.current[4]?.RevparIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[4]?.RevparIndexLy
                                                    ? tableDataRef.current[4]?.RevparIndexLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "friday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "friday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[5]?.RevparIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 5) {
                                                                        item.RevparIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.RevparIndexChange
                                                                            ? parseFloat(item.RevparIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[5].RevparIndex =
                                                                e.target.value;
                                                            tableDataRef.current[5].RevparIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[5]?.RevparIndex ? (
                                                    tableDataRef.current[5]?.RevparIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "friday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "friday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[5]?.RevparIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 5) {
                                                                        item.RevparIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparIndex
                                                                            ? parseFloat(item.RevparIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[5].RevparIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[5].RevparIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[5]?.RevparIndexChange ? (
                                                    tableDataRef.current[5]?.RevparIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[5]?.RevparIndexLy
                                                    ? tableDataRef.current[5]?.RevparIndexLy
                                                    : 0}
                                            </td>

                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "index",
                                            //     field: "curr",
                                            //     day: "saturday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "curr" &&
                                                    clickedTr.day === "saturday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[6]?.RevparIndex}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 6) {
                                                                        item.RevparIndex = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let changeValue = item?.RevparIndexChange
                                                                            ? parseFloat(item.RevparIndexChange)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (newValue * 100) /
                                                                            (100 + changeValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[6].RevparIndex =
                                                                e.target.value;
                                                            tableDataRef.current[6].RevparIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[6]?.RevparIndex ? (
                                                    tableDataRef.current[6]?.RevparIndex
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td
                                            // onDoubleClick={() => {
                                            //   setClickedTr({
                                            //     mainRow: "Revpar",
                                            //     subRow: "index",
                                            //     field: "change",
                                            //     day: "saturday",
                                            //   });
                                            // }}
                                            >
                                                {clickedTr.mainRow === "Revpar" &&
                                                    clickedTr.subRow === "index" &&
                                                    clickedTr.field === "change" &&
                                                    clickedTr.day === "saturday" ? (
                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("WeeklyStar", "form-control-onchange", propertyCode)}
                                                        maxLength={8}
                                                        type="text"
                                                        className="small-padding width50"
                                                        value={tableDataRef.current[6]?.RevparIndexChange}
                                                        onChange={(e) => {
                                                            let lyValue = "";
                                                            reportDataRef.current =
                                                                reportDataRef.current?.map((item, index) => {
                                                                    if (index === 6) {
                                                                        item.RevparIndexChange = e.target.value;

                                                                        let newValue = e.target.value
                                                                            ? parseFloat(e.target.value)
                                                                            : 0;
                                                                        let currValue = item?.RevparIndex
                                                                            ? parseFloat(item.RevparIndex)
                                                                            : 0;
                                                                        lyValue = (
                                                                            (currValue * 100) /
                                                                            (100 + newValue)
                                                                        )?.toFixed(2);
                                                                        item.RevparIndexLy = lyValue;
                                                                    }
                                                                    return item;
                                                                });
                                                            tableDataRef.current[6].RevparIndexChange =
                                                                e.target.value;
                                                            tableDataRef.current[6].RevparIndexLy = lyValue;
                                                            setReportData(reportDataRef.current);
                                                        }}
                                                    />
                                                ) : tableDataRef.current[6]?.RevparIndexChange ? (
                                                    tableDataRef.current[6]?.RevparIndexChange
                                                ) : (
                                                    0
                                                )}
                                            </td>
                                            <td className="border_right">
                                                {tableDataRef.current[6]?.RevparIndexLy
                                                    ? tableDataRef.current[6]?.RevparIndexLy
                                                    : 0}
                                            </td>
                                            <td className="fontBold">
                                                {tableDataRef.current[7]?.RevparIndex
                                                    ? tableDataRef.current[7]?.RevparIndex
                                                    : 0}
                                            </td>
                                            <td className="fontBold">
                                                {tableDataRef.current[7]?.RevparIndexChange
                                                    ? tableDataRef.current[7]?.RevparIndexChange
                                                    : 0}
                                            </td>
                                        </tr>
                                    </>
                                ) : (
                                    <tr>
                                        <td>No Data Found</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>

                <div className="mt-2">
                    <Row style={{ padding: 0, margin: 0, width: "100%" }}>
                        <div style={{ width: "33%" }} className="mt-2">
                            <h6>Occupancy</h6>
                            {loading ? (
                                <Loader />
                            ) : (
                                <Col xl={12}>
                                    {occChartData ? (
                                        <div className="snapShotBarWithLineChartInner">
                                            <Bar
                                                data={occChartData}
                                                options={occChartOption}
                                                style={{ height: "400px" }}
                                            />
                                        </div>
                                    ) : (
                                        <div className="snapShotBarWithLineChartInner text-center">
                                            No Data Found
                                        </div>
                                    )}
                                </Col>
                            )}
                        </div>
                        <div style={{ width: "33%" }} className="mt-2">
                            <h6>ADR</h6>
                            {loading ? (
                                <Loader />
                            ) : (
                                <Col xl={12}>
                                    {adrChartData ? (
                                        <div className="snapShotBarWithLineChartInner">
                                            <Bar
                                                data={adrChartData}
                                                options={occChartOption}
                                                style={{ height: "400px" }}
                                            />
                                        </div>
                                    ) : (
                                        <div className="snapShotBarWithLineChartInner text-center">
                                            No Data Found
                                        </div>
                                    )}
                                </Col>
                            )}
                        </div>
                        <div style={{ width: "33%" }} className="mt-2">
                            <h6>RevPAR</h6>
                            {loading ? (
                                <Loader />
                            ) : (
                                <Col xl={12}>
                                    {revParChartData ? (
                                        <div className="snapShotBarWithLineChartInner">
                                            <Bar
                                                data={revParChartData}
                                                options={occChartOption}
                                                style={{ height: "400px" }}
                                            />
                                        </div>
                                    ) : (
                                        <div className="snapShotBarWithLineChartInner text-center">
                                            No Data Found
                                        </div>
                                    )}
                                </Col>
                            )}
                        </div>
                    </Row>
                </div>

                {showNoteSidebar && (
                    <AddWidgetModal
                        showModal={showNoteSidebar}
                        closeModal={closeNoteSideBar}
                        widgetId={para?.widgetId}
                        propertyId={propertyDetailFromRTK?.propertyid}
                        rowTitle={para?.rowTitle}
                    />
                )}
                {widgetModal && (
                    <WidgetDetailModal
                        showModal={widgetModal}
                        closeModal={closeWidgetModal}
                        data={widgetDetailRef.current}
                    />
                )}
            </div>

            <div className="mt-3">
                <RunningStar
                    setCompDataFromChild={setCompDataFromChild}
                    rowIndex={rowIndex}
                    colIndex={colIndex}
                    api={api}
                    para={para}
                    setting={setting}
                    strData={strData}
                    fileImportLoading={fileImportLoading}
                    tableDataRefSecond={tableDataRefSecond}
                    setStrData={setStrData}
                    strDataRef={strDataRef}
                />
            </div>
        </>
    );
};

export default WeeklyStar;
